var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.07,259.48c-89.54-51.69-234.24-51.69-323.19,0S-.61,395,88.93,446.69s234.24,51.7,323.2,0S500.61,311.18,411.07,259.48Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.11,283.71l-70.68-40.64a9.55,9.55,0,0,0-9.55,0l-9.5,5.49a3.18,3.18,0,0,0,0,5.51l3.57,2.06-8.48,4.91a3.18,3.18,0,0,0,0,5.51l7.7,4.44L304,276.31a3.18,3.18,0,0,0,0,5.51l70.66,40.72a9.56,9.56,0,0,0,9.62,0l9.47-5.56a3.18,3.18,0,0,0,0-5.5l-7.64-4.4,9.13-5.36a3.18,3.18,0,0,0,0-5.5l-3.51-2,8.45-5A3.18,3.18,0,0,0,400.11,283.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.64,395.44c-22.67-13.08-59.31-13.08-81.83,0a42.23,42.23,0,0,0-10.55,8.43,19.77,19.77,0,0,0-6.42-5.61c-11.34-6.54-29.66-6.54-40.92,0s-11.2,17.16.14,23.71,29.65,6.54,40.91,0l.24-.14c1.1,7.67,6.71,15.16,16.87,21,22.67,13.09,59.3,13.09,81.83,0S352.31,408.53,329.64,395.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.86,268.82c-37.29-21.53-97.55-21.53-134.6,0s-36.86,56.44.43,78,97.56,21.53,134.61,0S256.15,290.35,218.86,268.82Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.71,408.39c-5.24-3-13.71-3-18.92,0s-5.18,7.93.07,11,13.71,3,18.91,0S165,411.42,159.71,408.39Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.39,382.5c-11.37-6.56-29.75-6.56-41,0s-11.24,17.21.13,23.78,29.75,6.56,41.05,0S146.76,389.07,135.39,382.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.37,344.06c-6.86-3.95-17.93-3.95-24.74,0s-6.78,10.37.08,14.33,17.93,4,24.74,0S277.22,348,270.37,344.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.08,379.28c-10.08-5.82-26.36-5.82-36.37,0s-10,15.25.12,21.06,26.36,5.82,36.37,0S415.16,385.09,405.08,379.28Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,351.31c-6.7-3.87-17.54-3.87-24.21,0s-6.62,10.15.08,14,17.55,3.87,24.21,0S73.75,355.19,67,351.31Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,331.16c-7.07-4.08-18.49-4.08-25.51,0s-7,10.7.08,14.78S441,350,448,345.94,455,335.24,448,331.16Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--palette-2--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.59,276.4h.05a2,2,0,0,0,.42-.11l.12-.06a2.15,2.15,0,0,0,1-1,3.63,3.63,0,0,0,.33-1.37c-.12-.06-.25-.1-.37-.17a6.89,6.89,0,0,1-.85-.59h0a10.16,10.16,0,0,1-.83-.79,10,10,0,0,1-.72-.89l0-.06a10.77,10.77,0,0,1-.58-.91l0-.07a10.16,10.16,0,0,1-.48-1h0a10.52,10.52,0,0,1-.36-1h0a9.39,9.39,0,0,1-.21-1v0a6.16,6.16,0,0,1-.07-.95h0c0-.11,0-.2,0-.29a2.72,2.72,0,0,0-2.69-.05,1.73,1.73,0,0,0-.3.25.81.81,0,0,0-.1.09l-.08.1-.08.1a2.07,2.07,0,0,0-.22.35,3.19,3.19,0,0,0-.27.77h0v0h0a4.82,4.82,0,0,0-.1.87h0v0a6.35,6.35,0,0,0,.07,1v0a8.9,8.9,0,0,0,.21,1h0a7.81,7.81,0,0,0,.35,1h0a10,10,0,0,0,.48,1l0,.07h0c.18.31.37.62.58.92h0l0,.05h0a8.75,8.75,0,0,0,.72.89,7.6,7.6,0,0,0,.83.79l0,0h0a6,6,0,0,0,.84.58,5.46,5.46,0,0,0,.59.3h0a4.23,4.23,0,0,0,.57.19h0a2.71,2.71,0,0,0,.54.08h0A2.57,2.57,0,0,0,388.59,276.4Z",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.69 187.2 356.07 218.65 356.07 218.65 395.22 261.16 410.84 229.71 371.69 187.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.19 182.19 413.33 224.69 428.96 193.24 393.17 154.38 389.81 150.74 374.19 182.19 374.19 182.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.92 114.27 392.3 145.72 392.3 145.72 431.45 188.22 447.07 156.77 438.49 147.45 407.92 114.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.59,283.52l.11-.13.13-.17a4.1,4.1,0,0,0,.26-.41l80.2-161.45L422.94,66.69,342.73,228.14c-1.21,2.42,0,6.77,2.72,9.71l40.56,44a9,9,0,0,0,2.16,1.77,3.7,3.7,0,0,0,3.91.3,2.31,2.31,0,0,0,.39-.31Zm17.83-174.28L426,77.79h0l29,31.54,10.1,11h0l-15.62,31.45-39.15-42.51Zm-2.5,5h0l30.57,33.18,8.58,9.32-15.62,31.45-39.15-42.5h0Zm-18.11,36.46h0l3.36,3.65L429,193.24h0l-15.63,31.45-39.15-42.5h0ZM371.69,187.2h0l39.15,42.51h0l-15.62,31.45-39.15-42.51h0Zm16.39,89.22a2.71,2.71,0,0,1-.54-.08h0a4.23,4.23,0,0,1-.57-.19h0a5.46,5.46,0,0,1-.59-.3,6,6,0,0,1-.84-.58l0,0a7.6,7.6,0,0,1-.83-.79,8.75,8.75,0,0,1-.72-.89l0-.05c-.21-.3-.4-.61-.58-.92l0-.07a10,10,0,0,1-.48-1h0a7.81,7.81,0,0,1-.35-1h0a8.9,8.9,0,0,1-.21-1v0a6.35,6.35,0,0,1-.07-1v0a4.82,4.82,0,0,1,.1-.87v0a3.19,3.19,0,0,1,.27-.77,2.07,2.07,0,0,1,.22-.35l.16-.2a.81.81,0,0,1,.1-.09,1.73,1.73,0,0,1,.3-.25A2.72,2.72,0,0,1,386,266a2.64,2.64,0,0,1,.38.18,7.33,7.33,0,0,1,1.7,1.4,8.91,8.91,0,0,1,2.46,6.23,3.63,3.63,0,0,1-.33,1.37,2.15,2.15,0,0,1-1,1l-.12.06a2,2,0,0,1-.42.11h-.05a2.57,2.57,0,0,1-.48,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.57 151.75 465.19 120.3 465.19 120.3 455.09 109.33 426.04 77.79 426.04 77.79 410.42 109.24 410.42 109.24 410.42 109.24 449.57 151.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.69 187.2 356.07 218.65 356.07 218.65 395.22 261.16 410.84 229.71 371.69 187.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.19 182.19 413.33 224.69 428.96 193.24 393.17 154.38 389.81 150.74 374.19 182.19 374.19 182.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.92 114.27 392.3 145.72 392.3 145.72 431.45 188.22 447.07 156.77 438.49 147.45 407.92 114.27",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.57 151.75 465.19 120.3 465.19 120.3 455.09 109.33 426.04 77.79 426.04 77.79 410.42 109.24 410.42 109.24 410.42 109.24 449.57 151.75",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.29,121.36l-80.2,161.45a4.1,4.1,0,0,1-.26.41l-.13.17-.11.13a.1.1,0,0,1,0,.05s-.05,0-.08.07a2.31,2.31,0,0,1-.39.31L392,284l3.81-2.21a2.69,2.69,0,0,0,.56-.46l.15-.18a2.78,2.78,0,0,0,.21-.27l.18-.31,80.2-161.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.1 119.15 426.74 64.47 422.94 66.69 473.29 121.36 477.1 119.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.29,121.36l-80.2,161.45a4.1,4.1,0,0,1-.26.41l-.13.17-.11.13a.1.1,0,0,1,0,.05s-.05,0-.08.07a2.31,2.31,0,0,1-.39.31L392,284l3.81-2.21a2.69,2.69,0,0,0,.56-.46l.15-.18a2.78,2.78,0,0,0,.21-.27l.18-.31,80.2-161.45Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.1 119.15 426.74 64.47 422.94 66.69 473.29 121.36 477.1 119.15",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.38,287.26a6.84,6.84,0,0,1-.82-.71l0,0a8.24,8.24,0,0,1-.72-.83l0,0a10.33,10.33,0,0,1-.6-.87l-.06-.09q-.28-.48-.51-1v0a9.79,9.79,0,0,1-.4-1h0a7.77,7.77,0,0,1-.26-1h0a7,7,0,0,1-.11-1v0c0-.21,0-.41,0-.61a2.66,2.66,0,0,0-2.75,0l-.18.14a2.33,2.33,0,0,0-.26.28.76.76,0,0,0-.11.14,2.49,2.49,0,0,0-.3.56h0a3.73,3.73,0,0,0-.19.75,4.86,4.86,0,0,0,0,.94v0a6.81,6.81,0,0,0,.11,1v0a6.41,6.41,0,0,0,.27,1h0a10,10,0,0,0,.4,1h0c.15.33.33.65.51,1l.06.1c.19.3.39.59.6.86l0,0a9.59,9.59,0,0,0,.72.82l0,0a6.84,6.84,0,0,0,.82.71,6.2,6.2,0,0,0,.65.44h0a5.46,5.46,0,0,0,.74.35h0a4.69,4.69,0,0,0,.69.18h0a2.85,2.85,0,0,0,.65,0h0a2.09,2.09,0,0,0,.56-.14l.08,0a2.49,2.49,0,0,0,1.38-2.08c0-.11,0-.23,0-.35a2.83,2.83,0,0,1-.36-.16A5.31,5.31,0,0,1,379.38,287.26Z",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.1 221.43 345.1 198.76 339.09 239 339.09 239 381.42 270.99 387.42 230.74 375.1 221.43",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.06 192.34 346.06 192.34 388.38 224.32 394.38 184.07 352.06 152.09 346.06 192.34",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.02 145.66 395.34 177.65 401.35 137.4 367.64 111.93 359.02 105.42 353.02 145.66 353.02 145.66",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.3 130.98 408.31 90.73 365.98 58.75 359.98 99 384.09 117.22 402.3 130.98",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.06 192.34 346.06 192.34 388.38 224.32 394.38 184.07 352.06 152.09 346.06 192.34",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.02 145.66 395.34 177.65 401.35 137.4 367.64 111.93 359.02 105.42 353.02 145.66 353.02 145.66",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.3 130.98 408.31 90.73 365.98 58.75 359.98 99 384.09 117.22 402.3 130.98",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.73,297.36l.18-.23a2.82,2.82,0,0,0,.25-.49c0-.09.09-.16.12-.25a4.84,4.84,0,0,0,.23-.91l30.81-206.6L360.88,47.74l-30.82,206.6c-.46,3.11,1.54,7.41,4.47,9.63l43.83,33.12a7.43,7.43,0,0,0,.83.55c1.56.9,3,.94,4,.24l.24-.18A3.39,3.39,0,0,0,383.73,297.36ZM366,58.75h0l42.33,32-6,40.25h0l-18.21-13.77L360,99Zm-7,46.67h0l8.62,6.51,33.71,25.47h0l-6,40.25-42.32-32h0Zm-7,46.67h0l42.32,32h0l-6,40.25-42.33-32h0Zm28.31,136.12a2.49,2.49,0,0,1-1.38,2.08l-.08,0a2.09,2.09,0,0,1-.56.14h0a2.85,2.85,0,0,1-.65,0h0a4.69,4.69,0,0,1-.69-.18h0a5.46,5.46,0,0,1-.74-.35h0a6.2,6.2,0,0,1-.65-.44,6.84,6.84,0,0,1-.82-.71l0,0a9.59,9.59,0,0,1-.72-.82l0,0c-.21-.27-.41-.56-.6-.86l-.06-.1c-.18-.31-.36-.63-.51-1h0a10,10,0,0,1-.4-1h0a6.41,6.41,0,0,1-.27-1v0a6.81,6.81,0,0,1-.11-1v0a4.86,4.86,0,0,1,0-.94,3.73,3.73,0,0,1,.19-.75h0a2.49,2.49,0,0,1,.3-.56.76.76,0,0,1,.11-.14,2.33,2.33,0,0,1,.26-.28l.18-.14a2.66,2.66,0,0,1,2.75,0l.38.18a6.07,6.07,0,0,1,.65.43,9.13,9.13,0,0,1,3.51,7.2C380.38,288,380.39,288.1,380.37,288.21ZM381.42,271l-42.33-32h0l6-40.24h0l30,22.67,12.32,9.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.51,295.48a4.69,4.69,0,0,1-.2.82l0,.05s0,0,0,0-.08.16-.12.25a3.73,3.73,0,0,1-.16.35.25.25,0,0,1,0,.07s0,0,0,.07l-.18.23-.06.08c-.05.05-.09.12-.14.17l-.11.09-.24.18a1.92,1.92,0,0,1-.17.13l3.81-2.21a2.49,2.49,0,0,0,.52-.4c.05,0,.09-.12.14-.17a4.19,4.19,0,0,0,.26-.33l0,0a.3.3,0,0,0,0-.08,1.71,1.71,0,0,0,.13-.23,2.88,2.88,0,0,0,.13-.31.32.32,0,0,0,0-.09l0-.05a.88.88,0,0,0,.05-.15,2.86,2.86,0,0,0,.07-.28l.06-.27a.69.69,0,0,1,0-.13L419.13,86.67l-3.81,2.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.69 45.53 360.88 47.74 415.32 88.88 419.13 86.67 419.13 86.67 364.69 45.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.51,295.48a4.69,4.69,0,0,1-.2.82l0,.05s0,0,0,0-.08.16-.12.25a3.73,3.73,0,0,1-.16.35.25.25,0,0,1,0,.07s0,0,0,.07l-.18.23-.06.08c-.05.05-.09.12-.14.17l-.11.09-.24.18a1.92,1.92,0,0,1-.17.13l3.81-2.21a2.49,2.49,0,0,0,.52-.4c.05,0,.09-.12.14-.17a4.19,4.19,0,0,0,.26-.33l0,0a.3.3,0,0,0,0-.08,1.71,1.71,0,0,0,.13-.23,2.88,2.88,0,0,0,.13-.31.32.32,0,0,0,0-.09l0-.05a.88.88,0,0,0,.05-.15,2.86,2.86,0,0,0,.07-.28l.06-.27a.69.69,0,0,1,0-.13L419.13,86.67l-3.81,2.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.69 45.53 360.88 47.74 415.32 88.88 419.13 86.67 419.13 86.67 364.69 45.53",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.93,305.79l.07,0a2.67,2.67,0,0,0,1.44-2.42l-.4-.2a7.67,7.67,0,0,1-.78-.53h0a8.78,8.78,0,0,1-.72-.66h0a9.72,9.72,0,0,1-.66-.76l0,0a8.7,8.7,0,0,1-.53-.77l-.1-.15c-.17-.28-.33-.56-.47-.85v0a9.77,9.77,0,0,1-.4-1h0a8.85,8.85,0,0,1-.28-1v0a8.62,8.62,0,0,1-.15-1,4.77,4.77,0,0,1,0-.93l-.08,0a2.59,2.59,0,0,0-2.78.12l-.13.13a2,2,0,0,0-.36.41v0a3.32,3.32,0,0,0-.3.66v0a4,4,0,0,0-.15.82h0a6.47,6.47,0,0,0,0,1,8.62,8.62,0,0,0,.15,1h0v0h0a8.25,8.25,0,0,0,.28,1h0v0a8.7,8.7,0,0,0,.4.95h0v0h0a8.76,8.76,0,0,0,.47.85h0c0,.06.07.11.1.16h0c.17.26.34.52.53.76h0l0,0h0a8.18,8.18,0,0,0,.66.76h0c.23.23.48.45.72.65h0a6.22,6.22,0,0,0,.77.53h0a5.06,5.06,0,0,0,.46.24h0a4.19,4.19,0,0,0,.82.28h0a3.13,3.13,0,0,0,.73.06h0A2.42,2.42,0,0,0,368.93,305.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.93,305.79l.07,0a2.67,2.67,0,0,0,1.44-2.42l-.4-.2a7.67,7.67,0,0,1-.78-.53h0a8.78,8.78,0,0,1-.72-.66h0a9.72,9.72,0,0,1-.66-.76l0,0a8.7,8.7,0,0,1-.53-.77l-.1-.15c-.17-.28-.33-.56-.47-.85v0a9.77,9.77,0,0,1-.4-1h0a8.85,8.85,0,0,1-.28-1v0a8.62,8.62,0,0,1-.15-1,4.77,4.77,0,0,1,0-.93l-.08,0a2.59,2.59,0,0,0-2.78.12l-.13.13a2,2,0,0,0-.36.41v0a3.32,3.32,0,0,0-.3.66v0a4,4,0,0,0-.15.82h0a6.47,6.47,0,0,0,0,1,8.62,8.62,0,0,0,.15,1h0v0h0a8.25,8.25,0,0,0,.28,1h0v0a8.7,8.7,0,0,0,.4.95h0v0h0a8.76,8.76,0,0,0,.47.85h0c0,.06.07.11.1.16h0c.17.26.34.52.53.76h0l0,0h0a8.18,8.18,0,0,0,.66.76h0c.23.23.48.45.72.65h0a6.22,6.22,0,0,0,.77.53h0a5.06,5.06,0,0,0,.46.24h0a4.19,4.19,0,0,0,.82.28h0a3.13,3.13,0,0,0,.73.06h0A2.42,2.42,0,0,0,368.93,305.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.8 217.59 321.5 225.64 324.82 263.89 324.82 263.89 324.82 263.89 367.44 283.17 363.41 236.88 320.8 217.59",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.81 102.83 310.81 102.83 353.43 122.1 349.41 75.81 306.79 56.53 310.81 102.83 310.81 102.83",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.46 110.21 315.49 156.51 315.49 156.51 315.49 156.51 358.1 175.79 354.07 129.5 311.46 110.21",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.57,312.5a3.3,3.3,0,0,0,.28-.35L375,312v0l.09-.16c0-.09.09-.18.13-.28s.05-.13.08-.2l.09-.31.06-.23.06-.36,0-.23c0-.14,0-.29,0-.43s0-.14,0-.22,0-.44,0-.68h0L354.86,71.17,300.05,46.38,320.71,284a11.92,11.92,0,0,0,5.32,8.58,4,4,0,0,0,.58.3l44.14,20A3.46,3.46,0,0,0,374,313a2.42,2.42,0,0,0,.45-.34Zm-67.78-256h0l42.62,19.28,4,46.29-42.61-19.27h0Zm8.35,95.95-3.68-42.27h0l42.61,19.29h0l4,46.29h0l-42.61-19.28Zm5,57.72h0l-4-46.29h0l42.61,19.28,4,46.29Zm.65,7.39h0l42.61,19.29h0l4,46.29-42.62-19.28h0Zm47.47,88.34a3.13,3.13,0,0,1-.73-.06h0a4.19,4.19,0,0,1-.82-.28h0a5.06,5.06,0,0,1-.46-.24h0a6.22,6.22,0,0,1-.77-.53h0c-.24-.2-.49-.42-.72-.65v0a8.18,8.18,0,0,1-.66-.76l0,0c-.19-.24-.36-.5-.53-.76,0-.05-.07-.1-.1-.16a8.76,8.76,0,0,1-.47-.85v0a8.7,8.7,0,0,1-.4-.95v0a8.25,8.25,0,0,1-.28-1v0a8.62,8.62,0,0,1-.15-1,6.47,6.47,0,0,1,0-1h0a4,4,0,0,1,.15-.82v0a3.32,3.32,0,0,1,.3-.66v0a2,2,0,0,1,.36-.41l.13-.13a2.59,2.59,0,0,1,2.78-.12l.08,0,.38.2a9.35,9.35,0,0,1,4.17,6.72,5.77,5.77,0,0,1,0,.93,2.67,2.67,0,0,1-1.44,2.42l-.07,0a2.42,2.42,0,0,1-.63.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.74 183.19 316.13 163.91 316.13 163.91 320.15 210.2 320.15 210.2 320.15 210.2 320.15 210.2 362.77 229.49 358.74 183.19",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.8 217.59 321.5 225.64 324.82 263.89 324.82 263.89 324.82 263.89 367.44 283.17 363.41 236.88 320.8 217.59",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.81 102.83 310.81 102.83 353.43 122.1 349.41 75.81 306.79 56.53 310.81 102.83 310.81 102.83",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.46 110.21 315.49 156.51 315.49 156.51 315.49 156.51 358.1 175.79 354.07 129.5 311.46 110.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.74 183.19 316.13 163.91 316.13 163.91 320.15 210.2 320.15 210.2 320.15 210.2 320.15 210.2 362.77 229.49 358.74 183.19",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.36,307.09a2.17,2.17,0,0,0,0-.26c0-.07,0-.14,0-.2L358.67,69h0l-3.81,2.21,20.67,237.67h0c0,.24,0,.46,0,.68v0h0c0,.06,0,.11,0,.17s0,.29,0,.43v.08l0,.15-.06.36s0,.06,0,.09v0l0,.11-.09.31s0,.07,0,.1,0,0,0,0a.08.08,0,0,1,0,.05c0,.1-.09.19-.13.28l0,0L375,312v0l-.12.18a3.3,3.3,0,0,1-.28.35l-.12.12a2.42,2.42,0,0,1-.45.34h0l3.81-2.22a2.19,2.19,0,0,0,.46-.34l.12-.13a3.17,3.17,0,0,0,.28-.34l.07-.09,0-.09.08-.14c0-.05.05-.09.07-.13a2.44,2.44,0,0,0,.1-.24l0-.05v0c0-.09.07-.19.1-.28a1.6,1.6,0,0,0,0-.21v-.07a2.21,2.21,0,0,0,0-.25c0-.09,0-.18,0-.26V308a.88.88,0,0,1,0-.16c0-.09,0-.17,0-.26s0-.15,0-.22v0h0A2.09,2.09,0,0,0,379.36,307.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.67 68.96 303.86 44.16 300.05 46.38 354.86 71.17 354.86 71.17 358.67 68.96 358.67 68.96",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.36,307.09a2.17,2.17,0,0,0,0-.26c0-.07,0-.14,0-.2L358.67,69h0l-3.81,2.21,20.67,237.67h0c0,.24,0,.46,0,.68v0h0c0,.06,0,.11,0,.17s0,.29,0,.43v.08l0,.15-.06.36s0,.06,0,.09v0l0,.11-.09.31s0,.07,0,.1,0,0,0,0a.08.08,0,0,1,0,.05c0,.1-.09.19-.13.28l0,0L375,312v0l-.12.18a3.3,3.3,0,0,1-.28.35l-.12.12a2.42,2.42,0,0,1-.45.34h0l3.81-2.22a2.19,2.19,0,0,0,.46-.34l.12-.13a3.17,3.17,0,0,0,.28-.34l.07-.09,0-.09.08-.14c0-.05.05-.09.07-.13a2.44,2.44,0,0,0,.1-.24l0-.05v0c0-.09.07-.19.1-.28a1.6,1.6,0,0,0,0-.21v-.07a2.21,2.21,0,0,0,0-.25c0-.09,0-.18,0-.26V308a.88.88,0,0,1,0-.16c0-.09,0-.17,0-.26s0-.15,0-.22v0h0A2.09,2.09,0,0,0,379.36,307.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.67 68.96 303.86 44.16 300.05 46.38 354.86 71.17 354.86 71.17 358.67 68.96 358.67 68.96",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--palette-1--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.36,126.38C232.69,168,242.42,221,229.14,270.68a105.08,105.08,0,0,1-12.86,29c-3.72,5.95-8.14,11.62-13.34,14.63a17.77,17.77,0,0,1-2.91,1.35c-14.67,5.21-26.94-13.31-41.79-12.77a24.71,24.71,0,0,0-11.35,3.7,98.14,98.14,0,0,0-12.46,9.15A99.66,99.66,0,0,1,122,324.89a24.8,24.8,0,0,1-11.17,3.69c-7.1.35-13.59-3.66-19.49-8.18C52.81,291,25.45,234.88,27.8,172.08c1.28-34,12.53-69.25,32.61-92.91A91.45,91.45,0,0,1,84.31,59c20.53-11.85,43.92-13.87,64.38-6.27C177.75,63.56,201,91.86,215.36,126.38ZM129.71,277.52c8.14-6.34,10.71-21.73,5.74-34.37-4.65-11.84-14.26-17.07-22.15-12.51a13.32,13.32,0,0,0-1.61,1.08c-8.13,6.34-10.71,21.73-5.74,34.37,4.65,11.83,14.26,17.06,22.15,12.51a16.16,16.16,0,0,0,1.61-1.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.51,128.88c17.33,41.59,27.06,94.6,13.78,144.31a105.51,105.51,0,0,1-12.86,29c-3.72,5.95-8.14,11.62-13.34,14.62a17.12,17.12,0,0,1-2.92,1.36c-14.66,5.21-26.93-13.31-41.79-12.77A24.57,24.57,0,0,0,151,309.1a98.24,98.24,0,0,0-12.46,9.16,100.4,100.4,0,0,1-12.45,9.14A24.92,24.92,0,0,1,115,331.09c-7.1.35-13.59-3.67-19.5-8.18C57,293.47,29.6,237.39,32,174.59c1.28-34,12.53-69.25,32.61-92.91a91.09,91.09,0,0,1,23.9-20.13C109,49.7,132.37,47.67,152.84,55.28,181.9,66.06,205.11,94.36,219.51,128.88ZM133.86,280c8.14-6.34,10.71-21.73,5.73-34.37-4.64-11.83-14.25-17.06-22.15-12.5a13.22,13.22,0,0,0-1.6,1.08c-8.14,6.33-10.72,21.73-5.74,34.37,4.65,11.83,14.26,17.06,22.15,12.5a14.15,14.15,0,0,0,1.61-1.08",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,125.33a4.45,4.45,0,0,1,1.42-.53A4.71,4.71,0,0,1,77.11,127c.47.7.83,1.52,1.33,2.2s1.53,1.62,2.24,1.36a21,21,0,0,0,3.15-1.49,29.26,29.26,0,0,0,12-14.47,12,12,0,0,1,1.46-2.94,3,3,0,0,1,.88-.79,1.58,1.58,0,0,1,1.57-.11c1,.49,1.33,2.08,1.08,3.38a8,8,0,0,1-1.72,3.33c-1.61,2.06-3.44,3.83-5,5.91a16.39,16.39,0,0,0-3.38,7.47c-.41,2.86.35,6.12,2.25,7.58.79.62,1.84,1.09,2,2.26.24,1.65-1.45,2.66-2,4.21-.61,1.85.55,3.74,1.14,5.56a10,10,0,0,1-.41,7,7,7,0,0,1-2.77,3.13,5,5,0,0,1-1.84.63,3.16,3.16,0,0,0-1.23.42c-1.92,1.11-3.09,4.13-3.34,7a17.05,17.05,0,0,0,2.23,9.63c.55,1,1.2,2.36.62,3.39a1.25,1.25,0,0,1-.43.45c-.77.44-1.91-.4-2.38-1.48-.56-1.31-.83-3-1.84-3.72a1.88,1.88,0,0,0-2.16.05,7.77,7.77,0,0,0-2.09,2,9,9,0,0,1-2.3,2.24,1.94,1.94,0,0,1-1.9.17c-2.47-1.21-1.46-7.28-4-8.38a2,2,0,0,0-1.92.24c-.91.52-1.8,1.47-2.69,2.1a4.25,4.25,0,0,1-.39.25,4.84,4.84,0,0,1-6.06-1,9.12,9.12,0,0,1-1.69-8.11c.68-2.53,2.39-4.79,2.15-7.43a4.94,4.94,0,0,0-3.48-4.26,11.27,11.27,0,0,0-5.12.25,7.88,7.88,0,0,1-5.08-.26,2.78,2.78,0,0,1-1.39-1.38,2.14,2.14,0,0,1,.23-2.13,1.51,1.51,0,0,1,.26-.2c.67-.39,1.53.19,2.21.69a10.55,10.55,0,0,0,11.73.7c1-.59,1.22-2.48,1.09-3.76s-.53-2.47-.65-3.75c-.27-2.8,1.06-5.76,3.06-6.91.84-.46,1.67-.64,2.4-1.07a3,3,0,0,0,.63-.46,7,7,0,0,0,1.74-3.65,27.75,27.75,0,0,1,1-4.16A6.51,6.51,0,0,1,71,125.33Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71,125.33a4.45,4.45,0,0,1,1.42-.53A4.71,4.71,0,0,1,77.11,127c.47.7.83,1.52,1.33,2.2s1.53,1.62,2.24,1.36a21,21,0,0,0,3.15-1.49,29.26,29.26,0,0,0,12-14.47,12,12,0,0,1,1.46-2.94,3,3,0,0,1,.88-.79,1.58,1.58,0,0,1,1.57-.11c1,.49,1.33,2.08,1.08,3.38a8,8,0,0,1-1.72,3.33c-1.61,2.06-3.44,3.83-5,5.91a16.39,16.39,0,0,0-3.38,7.47c-.41,2.86.35,6.12,2.25,7.58.79.62,1.84,1.09,2,2.26.24,1.65-1.45,2.66-2,4.21-.61,1.85.55,3.74,1.14,5.56a10,10,0,0,1-.41,7,7,7,0,0,1-2.77,3.13,5,5,0,0,1-1.84.63,3.16,3.16,0,0,0-1.23.42c-1.92,1.11-3.09,4.13-3.34,7a17.05,17.05,0,0,0,2.23,9.63c.55,1,1.2,2.36.62,3.39a1.25,1.25,0,0,1-.43.45c-.77.44-1.91-.4-2.38-1.48-.56-1.31-.83-3-1.84-3.72a1.88,1.88,0,0,0-2.16.05,7.77,7.77,0,0,0-2.09,2,9,9,0,0,1-2.3,2.24,1.94,1.94,0,0,1-1.9.17c-2.47-1.21-1.46-7.28-4-8.38a2,2,0,0,0-1.92.24c-.91.52-1.8,1.47-2.69,2.1a4.25,4.25,0,0,1-.39.25,4.84,4.84,0,0,1-6.06-1,9.12,9.12,0,0,1-1.69-8.11c.68-2.53,2.39-4.79,2.15-7.43a4.94,4.94,0,0,0-3.48-4.26,11.27,11.27,0,0,0-5.12.25,7.88,7.88,0,0,1-5.08-.26,2.78,2.78,0,0,1-1.39-1.38,2.14,2.14,0,0,1,.23-2.13,1.51,1.51,0,0,1,.26-.2c.67-.39,1.53.19,2.21.69a10.55,10.55,0,0,0,11.73.7c1-.59,1.22-2.48,1.09-3.76s-.53-2.47-.65-3.75c-.27-2.8,1.06-5.76,3.06-6.91.84-.46,1.67-.64,2.4-1.07a3,3,0,0,0,.63-.46,7,7,0,0,0,1.74-3.65,27.75,27.75,0,0,1,1-4.16A6.51,6.51,0,0,1,71,125.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,101.18c.66-.25,1.2.33,1.37,1a6.11,6.11,0,0,1,0,2.13,46.73,46.73,0,0,0-.19,10,11.31,11.31,0,0,0,.66,3.23,3.05,3.05,0,0,0,1.94,2,2.82,2.82,0,0,0,2-.51l.56-.34.54-.33c1-.58,2-1,3.2,0a5.39,5.39,0,0,1,1.71,3.87c.15,2.66-.93,5.11-2,7.42a5.68,5.68,0,0,0,.6,5.73c.53.64,1.07,1.31,1.6,2.06,1.22,1.74,3.44,1.76,5.21.74a5.52,5.52,0,0,0,1.24-1,6.28,6.28,0,0,1,1.21-1.16,1.2,1.2,0,0,1,.33-.13c.89-.25,1.81.89,1.66,2.06a2.34,2.34,0,0,1-1.17,1.72,2.3,2.3,0,0,1-.82.29,16,16,0,0,1-2.67-.15,2.53,2.53,0,0,0-1.39.36c-1.7,1-2.6,3.77-1.75,6.14a50.38,50.38,0,0,1,2.64,9.76c.66,4.63.24,9.77-2,13.61-1.27,2.21-3,3.85-4.43,5.94s-2.42,5-1.74,7.53c.42,1.58,1.45,2.84,1.42,4.65a2.26,2.26,0,0,1-.89,1.93c-.89.5-1.62-.32-2-1.25a14,14,0,0,1-.64-3.53,7.81,7.81,0,0,0-.93-3.37,1.82,1.82,0,0,0-2.33-.9l-.17.12a5,5,0,0,0-1.22,2.8A3.75,3.75,0,0,1,184,185.9a1.11,1.11,0,0,1-.27.12c-.81.21-1.56-.62-2-1.51a7.49,7.49,0,0,0-1.52-2.47c-1.13-.89-2.59-.15-3.9.16-4.08,1-8.19-2.8-9.54-7.83a21.28,21.28,0,0,1,.56-11.82,23.72,23.72,0,0,0,1-9.57,25.13,25.13,0,0,1-.16-3,3.6,3.6,0,0,0-.36-2c-.6-.85-1.65-.48-2.49,0-3.09,1.83-6.16,3.68-8.45,6.76a7.35,7.35,0,0,1-1.36,1.59l-.19.13a1.25,1.25,0,0,1-1.53-.09,2.33,2.33,0,0,1,.05-2.75,2,2,0,0,1,.62-.55,2.57,2.57,0,0,1,1.62-.29c2.29-1.7,4.83-3.32,7.12-5a32.3,32.3,0,0,0,5.91-5.18,15.05,15.05,0,0,0,3.48-7.86c.2-1.82-1.59-2.93-2.35-4.45a11.42,11.42,0,0,1-.73-7.69,8.93,8.93,0,0,1,3.89-5.54l.27-.15a3.14,3.14,0,0,1,2.64-.29,5.59,5.59,0,0,1,1.86,1.69,2.48,2.48,0,0,0,3.27.62,3.54,3.54,0,0,0,1.42-1.61,13.26,13.26,0,0,0,1.13-4.43,36.52,36.52,0,0,0-.81-9C183,102.93,183,101.57,183.67,101.18Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.67,101.18c.66-.25,1.2.33,1.37,1a6.11,6.11,0,0,1,0,2.13,46.73,46.73,0,0,0-.19,10,11.31,11.31,0,0,0,.66,3.23,3.05,3.05,0,0,0,1.94,2,2.82,2.82,0,0,0,2-.51l.56-.34.54-.33c1-.58,2-1,3.2,0a5.39,5.39,0,0,1,1.71,3.87c.15,2.66-.93,5.11-2,7.42a5.68,5.68,0,0,0,.6,5.73c.53.64,1.07,1.31,1.6,2.06,1.22,1.74,3.44,1.76,5.21.74a5.52,5.52,0,0,0,1.24-1,6.28,6.28,0,0,1,1.21-1.16,1.2,1.2,0,0,1,.33-.13c.89-.25,1.81.89,1.66,2.06a2.34,2.34,0,0,1-1.17,1.72,2.3,2.3,0,0,1-.82.29,16,16,0,0,1-2.67-.15,2.53,2.53,0,0,0-1.39.36c-1.7,1-2.6,3.77-1.75,6.14a50.38,50.38,0,0,1,2.64,9.76c.66,4.63.24,9.77-2,13.61-1.27,2.21-3,3.85-4.43,5.94s-2.42,5-1.74,7.53c.42,1.58,1.45,2.84,1.42,4.65a2.26,2.26,0,0,1-.89,1.93c-.89.5-1.62-.32-2-1.25a14,14,0,0,1-.64-3.53,7.81,7.81,0,0,0-.93-3.37,1.82,1.82,0,0,0-2.33-.9l-.17.12a5,5,0,0,0-1.22,2.8A3.75,3.75,0,0,1,184,185.9a1.11,1.11,0,0,1-.27.12c-.81.21-1.56-.62-2-1.51a7.49,7.49,0,0,0-1.52-2.47c-1.13-.89-2.59-.15-3.9.16-4.08,1-8.19-2.8-9.54-7.83a21.28,21.28,0,0,1,.56-11.82,23.72,23.72,0,0,0,1-9.57,25.13,25.13,0,0,1-.16-3,3.6,3.6,0,0,0-.36-2c-.6-.85-1.65-.48-2.49,0-3.09,1.83-6.16,3.68-8.45,6.76a7.35,7.35,0,0,1-1.36,1.59l-.19.13a1.25,1.25,0,0,1-1.53-.09,2.33,2.33,0,0,1,.05-2.75,2,2,0,0,1,.62-.55,2.57,2.57,0,0,1,1.62-.29c2.29-1.7,4.83-3.32,7.12-5a32.3,32.3,0,0,0,5.91-5.18,15.05,15.05,0,0,0,3.48-7.86c.2-1.82-1.59-2.93-2.35-4.45a11.42,11.42,0,0,1-.73-7.69,8.93,8.93,0,0,1,3.89-5.54l.27-.15a3.14,3.14,0,0,1,2.64-.29,5.59,5.59,0,0,1,1.86,1.69,2.48,2.48,0,0,0,3.27.62,3.54,3.54,0,0,0,1.42-1.61,13.26,13.26,0,0,0,1.13-4.43,36.52,36.52,0,0,0-.81-9C183,102.93,183,101.57,183.67,101.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.4,74a2.24,2.24,0,0,1,1.38-.27c1.78.24,3,1.92,4.45,2.92a5.78,5.78,0,0,0,6.21.07,7.79,7.79,0,0,0,2.8-2.84,4.94,4.94,0,0,1,2-4.22,3.51,3.51,0,0,1,.4-.27,3.07,3.07,0,0,1,3.57.33c.56.46,1,1.13,1.58,1.59,1.29,1,3,.84,4.49,1a6.06,6.06,0,0,1,3.72,1.8,1.84,1.84,0,0,0,2.36.48,2.29,2.29,0,0,0,.93-1.08,39.3,39.3,0,0,1,1.46-3.74,3.27,3.27,0,0,1,1.15-1.21,1.36,1.36,0,0,1,1.61,0c.9.73.87,2.57.24,3.71a7.64,7.64,0,0,1-2.61,2.46,5.51,5.51,0,0,0-2.31,2.84c-.58,2,.39,4,1.31,5.73,1.3,2.4,3,4.91,4.33,7.31a1.73,1.73,0,0,0,1.26-.25,4.88,4.88,0,0,0,1.15-1,9.54,9.54,0,0,1,2-2,1.57,1.57,0,0,1,2.37.86A2.61,2.61,0,0,1,160,91l-.16.08c-.91.43-1.91.42-2.79.93a2.57,2.57,0,0,0-1.09,3c.52,1,1.68.77,2.58.43l4.27-1.58c.74-.28,1.6-.55,2.21.17a2.64,2.64,0,0,1,0,3,2.81,2.81,0,0,1-.91.88,3.81,3.81,0,0,1-2.53.31,8,8,0,0,0-3.25-.24,3,3,0,0,0-.85.35c-1.87,1.08-3,3.91-3.87,6.45a13.36,13.36,0,0,0-1,5.4c.24,2.66,2,5,1.55,7.62a4.62,4.62,0,0,1-2.28,3.21,4.72,4.72,0,0,1-1.43.54c-1.63.33-3.29-.06-5,0a5.81,5.81,0,0,0-2.79.73A4.34,4.34,0,0,0,141,124a16.31,16.31,0,0,0-1.13,3.86,4.86,4.86,0,0,1-1.75,3l-.17.08c-1.46.65-2.89-1-3.73-2.62s-1.7-4.39-3.21-4c-4.09,1.09-8.54-1.08-11-5.37a17.1,17.1,0,0,0-1.69-2.79,2.1,2.1,0,0,0-2.55-.73c-.87.51-1.26,1.8-1.73,2.88a3.88,3.88,0,0,1-1.36,1.82,1.06,1.06,0,0,1-1.06,0,2.33,2.33,0,0,1-.75-2.68c.62-2,2.15-2.52,3.45-3.43a4.11,4.11,0,0,0,1.88-3.57c-.34-3.06-3.51-2.55-5-3.94a2.25,2.25,0,0,1-.63-.89,1.38,1.38,0,0,1,.07-1.16.91.91,0,0,1,.27-.25.87.87,0,0,1,.57-.1c.31,0,.6.14.92.18a1.48,1.48,0,0,0,.91-.2c1-.61,1.54-2.47,1.62-3.89s-.1-2.9,0-4.36a12.56,12.56,0,0,1,1.14-4.61c1-2.18,2.75-4.25,2.42-6.72-.25-1.89-1.63-3.09-2.74-4.34s-2.26-3.66-1.13-5.43A2.44,2.44,0,0,1,115.4,74Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.4,74a2.24,2.24,0,0,1,1.38-.27c1.78.24,3,1.92,4.45,2.92a5.78,5.78,0,0,0,6.21.07,7.79,7.79,0,0,0,2.8-2.84,4.94,4.94,0,0,1,2-4.22,3.51,3.51,0,0,1,.4-.27,3.07,3.07,0,0,1,3.57.33c.56.46,1,1.13,1.58,1.59,1.29,1,3,.84,4.49,1a6.06,6.06,0,0,1,3.72,1.8,1.84,1.84,0,0,0,2.36.48,2.29,2.29,0,0,0,.93-1.08,39.3,39.3,0,0,1,1.46-3.74,3.27,3.27,0,0,1,1.15-1.21,1.36,1.36,0,0,1,1.61,0c.9.73.87,2.57.24,3.71a7.64,7.64,0,0,1-2.61,2.46,5.51,5.51,0,0,0-2.31,2.84c-.58,2,.39,4,1.31,5.73,1.3,2.4,3,4.91,4.33,7.31a1.73,1.73,0,0,0,1.26-.25,4.88,4.88,0,0,0,1.15-1,9.54,9.54,0,0,1,2-2,1.57,1.57,0,0,1,2.37.86A2.61,2.61,0,0,1,160,91l-.16.08c-.91.43-1.91.42-2.79.93a2.57,2.57,0,0,0-1.09,3c.52,1,1.68.77,2.58.43l4.27-1.58c.74-.28,1.6-.55,2.21.17a2.64,2.64,0,0,1,0,3,2.81,2.81,0,0,1-.91.88,3.81,3.81,0,0,1-2.53.31,8,8,0,0,0-3.25-.24,3,3,0,0,0-.85.35c-1.87,1.08-3,3.91-3.87,6.45a13.36,13.36,0,0,0-1,5.4c.24,2.66,2,5,1.55,7.62a4.62,4.62,0,0,1-2.28,3.21,4.72,4.72,0,0,1-1.43.54c-1.63.33-3.29-.06-5,0a5.81,5.81,0,0,0-2.79.73A4.34,4.34,0,0,0,141,124a16.31,16.31,0,0,0-1.13,3.86,4.86,4.86,0,0,1-1.75,3l-.17.08c-1.46.65-2.89-1-3.73-2.62s-1.7-4.39-3.21-4c-4.09,1.09-8.54-1.08-11-5.37a17.1,17.1,0,0,0-1.69-2.79,2.1,2.1,0,0,0-2.55-.73c-.87.51-1.26,1.8-1.73,2.88a3.88,3.88,0,0,1-1.36,1.82,1.06,1.06,0,0,1-1.06,0,2.33,2.33,0,0,1-.75-2.68c.62-2,2.15-2.52,3.45-3.43a4.11,4.11,0,0,0,1.88-3.57c-.34-3.06-3.51-2.55-5-3.94a2.25,2.25,0,0,1-.63-.89,1.38,1.38,0,0,1,.07-1.16.91.91,0,0,1,.27-.25.87.87,0,0,1,.57-.1c.31,0,.6.14.92.18a1.48,1.48,0,0,0,.91-.2c1-.61,1.54-2.47,1.62-3.89s-.1-2.9,0-4.36a12.56,12.56,0,0,1,1.14-4.61c1-2.18,2.75-4.25,2.42-6.72-.25-1.89-1.63-3.09-2.74-4.34s-2.26-3.66-1.13-5.43A2.44,2.44,0,0,1,115.4,74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,198.21c.53-.2.94.35,1.18.87.8,1.72,1.23,3.72,2.16,5.31s2.56,2.64,3.93,1.85c.63-.42,1.08-1,1.58-1.29a1.19,1.19,0,0,1,.57-.18c.6,0,1.12.59,1.71.63a1.17,1.17,0,0,0,.7-.18,4.93,4.93,0,0,0,1-.88,5,5,0,0,1,1-.9,1.46,1.46,0,0,1,.45-.18c1-.18,1.81.89,2.77,1.15s2-.31,3-.62a5.42,5.42,0,0,1,4.87.9,8.6,8.6,0,0,1,3,5,2.73,2.73,0,0,0,2.38,2.18,3.59,3.59,0,0,0,1.81-.54,8.66,8.66,0,0,0,1-.7,3,3,0,0,1,.43-.3.74.74,0,0,1,.29-.12.61.61,0,0,1,.7.3,1.14,1.14,0,0,1-.13,1,2.26,2.26,0,0,1-.74.61l-2.06,1.2a2.13,2.13,0,0,0-1.15,1.25,2,2,0,0,0,.76,1.9c.51.38,1.12.53,1.62.92a3.62,3.62,0,0,1,1.26,2.67c-1.26,1.51-1.36,4.66-.81,6.74a8.89,8.89,0,0,1,.69,3.17c-.15,1.56-1.5,2.62-1.63,4.19s1,3.13.54,4.6c-.44,1.27-1.88,1.52-2.36,2.76a2.84,2.84,0,0,0,.65,2.88,4.43,4.43,0,0,0,2,1,3.58,3.58,0,0,0,1.72.08c.44-.1,1-.25,1.28.42a1.11,1.11,0,0,1-.46,1.22,1.49,1.49,0,0,1-1.26-.12,8.88,8.88,0,0,0-2.6-1.21,1.86,1.86,0,0,0-1.09.24,1.92,1.92,0,0,0-1,1.64,2.62,2.62,0,0,0,.76,1.75,12.82,12.82,0,0,1,1.26,1.29,5.82,5.82,0,0,1,.77,4,8.77,8.77,0,0,1-3.27,6.12c-.15.1-.29.2-.44.28a5.08,5.08,0,0,1-5.25,0c-.81-.49-1.64-1.25-2.51-1a1.23,1.23,0,0,0-.26.12,4.47,4.47,0,0,0-1.35,1.7,4.34,4.34,0,0,1-1.31,1.66,1.2,1.2,0,0,1-.31.13c-.77.23-1.52-.37-2.08-1.07a10,10,0,0,0-1.69-2c-1.72-1.26-4.13.21-5.8-1.15-1.28-1-1.58-3.31-1.39-5.27a43.3,43.3,0,0,0,.63-5.88,3.15,3.15,0,0,0-.32-1.42.84.84,0,0,0-1-.49,2.11,2.11,0,0,0-.75,1.33,2.16,2.16,0,0,1-.71,1.36c-.41.24-1-.36-.71-.82,1.42-2.45,0-6.42-2-7.81-1-.68-2.26-.86-3-1.95a6.65,6.65,0,0,1-.71-4.09,12.61,12.61,0,0,0-.13-4.3c-.63-2.11-2.54-3.18-3.28-5.25a7.64,7.64,0,0,1,1-6.29,22.2,22.2,0,0,1,4.09-4.28A16.55,16.55,0,0,0,62.51,209a5.53,5.53,0,0,0-.59-4.79c-.81-1.35-1.91-2.36-2.71-3.71a2.68,2.68,0,0,1-.44-1.22A1.21,1.21,0,0,1,59.2,198.21Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2,198.21c.53-.2.94.35,1.18.87.8,1.72,1.23,3.72,2.16,5.31s2.56,2.64,3.93,1.85c.63-.42,1.08-1,1.58-1.29a1.19,1.19,0,0,1,.57-.18c.6,0,1.12.59,1.71.63a1.17,1.17,0,0,0,.7-.18,4.93,4.93,0,0,0,1-.88,5,5,0,0,1,1-.9,1.46,1.46,0,0,1,.45-.18c1-.18,1.81.89,2.77,1.15s2-.31,3-.62a5.42,5.42,0,0,1,4.87.9,8.6,8.6,0,0,1,3,5,2.73,2.73,0,0,0,2.38,2.18,3.59,3.59,0,0,0,1.81-.54,8.66,8.66,0,0,0,1-.7,3,3,0,0,1,.43-.3.74.74,0,0,1,.29-.12.61.61,0,0,1,.7.3,1.14,1.14,0,0,1-.13,1,2.26,2.26,0,0,1-.74.61l-2.06,1.2a2.13,2.13,0,0,0-1.15,1.25,2,2,0,0,0,.76,1.9c.51.38,1.12.53,1.62.92a3.62,3.62,0,0,1,1.26,2.67c-1.26,1.51-1.36,4.66-.81,6.74a8.89,8.89,0,0,1,.69,3.17c-.15,1.56-1.5,2.62-1.63,4.19s1,3.13.54,4.6c-.44,1.27-1.88,1.52-2.36,2.76a2.84,2.84,0,0,0,.65,2.88,4.43,4.43,0,0,0,2,1,3.58,3.58,0,0,0,1.72.08c.44-.1,1-.25,1.28.42a1.11,1.11,0,0,1-.46,1.22,1.49,1.49,0,0,1-1.26-.12,8.88,8.88,0,0,0-2.6-1.21,1.86,1.86,0,0,0-1.09.24,1.92,1.92,0,0,0-1,1.64,2.62,2.62,0,0,0,.76,1.75,12.82,12.82,0,0,1,1.26,1.29,5.82,5.82,0,0,1,.77,4,8.77,8.77,0,0,1-3.27,6.12c-.15.1-.29.2-.44.28a5.08,5.08,0,0,1-5.25,0c-.81-.49-1.64-1.25-2.51-1a1.23,1.23,0,0,0-.26.12,4.47,4.47,0,0,0-1.35,1.7,4.34,4.34,0,0,1-1.31,1.66,1.2,1.2,0,0,1-.31.13c-.77.23-1.52-.37-2.08-1.07a10,10,0,0,0-1.69-2c-1.72-1.26-4.13.21-5.8-1.15-1.28-1-1.58-3.31-1.39-5.27a43.3,43.3,0,0,0,.63-5.88,3.15,3.15,0,0,0-.32-1.42.84.84,0,0,0-1-.49,2.11,2.11,0,0,0-.75,1.33,2.16,2.16,0,0,1-.71,1.36c-.41.24-1-.36-.71-.82,1.42-2.45,0-6.42-2-7.81-1-.68-2.26-.86-3-1.95a6.65,6.65,0,0,1-.71-4.09,12.61,12.61,0,0,0-.13-4.3c-.63-2.11-2.54-3.18-3.28-5.25a7.64,7.64,0,0,1,1-6.29,22.2,22.2,0,0,1,4.09-4.28A16.55,16.55,0,0,0,62.51,209a5.53,5.53,0,0,0-.59-4.79c-.81-1.35-1.91-2.36-2.71-3.71a2.68,2.68,0,0,1-.44-1.22A1.21,1.21,0,0,1,59.2,198.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M132.21,164.9a3.48,3.48,0,0,1,1,2.35,4.8,4.8,0,0,0,.86,2.52,1.51,1.51,0,0,0,1.91.15,2.65,2.65,0,0,0,.59-.48,8.44,8.44,0,0,0,1.47-3,3.61,3.61,0,0,1,1.23-2.08c.63-.35,1.32.15,1.44,1a18.49,18.49,0,0,0,1.63,6.1c1,1.8,2.83,3,4.46,2.27l.26-.14a7.42,7.42,0,0,0,1-.78,9.18,9.18,0,0,1,1.05-.78,1.81,1.81,0,0,1,1.62-.19,2.88,2.88,0,0,1,1.53,2c.53,2,0,4-.45,5.88a10.09,10.09,0,0,0-.22,4.78,12.21,12.21,0,0,0,2.06,3.58,5.3,5.3,0,0,1,1,4.09,6.47,6.47,0,0,1-2.21,3c-.86.84-1.81,1.83-1.55,3.17a11.6,11.6,0,0,1,.3,2.88,3.37,3.37,0,0,1-1.1,2.46l-.15.1a3.11,3.11,0,0,1-1.71.26,3,3,0,0,0-1.71.26c-1.23.87-1.5,3-2.65,3.7-1,.51-2-.19-2.95.18l-.21.1c-1,.57-1.48,2.14-2.41,2.9a2,2,0,0,1-.31.22c-1.26.73-2.8,0-4-.9s-2.86-2-4.32-1.36l-.22.11c-1.41.82-2.09,3-3.12,4.55a6.63,6.63,0,0,1-2.16,2.07,4.9,4.9,0,0,1-4.49.32,9.54,9.54,0,0,0-2-.9,1.77,1.77,0,0,0-1.27.2,2.07,2.07,0,0,0-.59.52,4.46,4.46,0,0,1-1.28,1.11,3.45,3.45,0,0,1-2.45.44,4.5,4.5,0,0,1-3.11-3c-.5-1.33-.61-3-1.45-4s-2-1.18-2.38-2.41.33-2.58.32-3.92a6.2,6.2,0,0,0-1.65-3.61,5.45,5.45,0,0,1-1.45-3.72c.15-1.59,1.34-2.61,2.39-3.46a4.87,4.87,0,0,0,2.2-3.63c0-.46-.12-.9-.12-1.37a1.4,1.4,0,0,1,.45-1.17c.26-.15.58-.07.83-.22.46-.33.44-1.11.28-1.68a3.11,3.11,0,0,1-.25-1.74,1,1,0,0,1,.45-.61,1.44,1.44,0,0,1,1.53.23c.64.52,1.18,1.35,1.94,1.46a1.32,1.32,0,0,0,.86-.19,4.37,4.37,0,0,0,1.36-1.51,6.08,6.08,0,0,1,1.78-2.27l.16-.09c1.2-.55,2.44.49,3.46,1.45a10,10,0,0,0,.92.79,1.41,1.41,0,0,0,1.6.09,2.68,2.68,0,0,0,.86-3.48,15.74,15.74,0,0,0-2.22-2.66,2.14,2.14,0,0,1-.68-1.63,1.16,1.16,0,0,1,.57-.87,1,1,0,0,1,.77-.11,2.65,2.65,0,0,1,1.33,1.28,6.55,6.55,0,0,0,1.15,1.59,1.74,1.74,0,0,0,2,.17,2.22,2.22,0,0,0,.27-.19,3.24,3.24,0,0,0,1-2.68c-.07-.66-.31-1.26-.37-1.91a1.75,1.75,0,0,1,.55-1.61c.56-.22,1,.25,1.47.48a1.55,1.55,0,0,0,1.5-.08,2.7,2.7,0,0,0,1.26-2.05,14.84,14.84,0,0,0-.17-2.3A2.44,2.44,0,0,1,132.21,164.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.27,216.35a1.75,1.75,0,0,1,.24-.11c2.3-.92,4,3.89,6.37,3.26a1.86,1.86,0,0,0,.46-.19,5.68,5.68,0,0,0,1.26-1.16,5.86,5.86,0,0,1,1.3-1.16l.25-.13c1.17-.48,2.41.38,3.28,1.46a22.28,22.28,0,0,0,2.6,3.26,3.46,3.46,0,0,0,3.68.51,21.08,21.08,0,0,0,8.19-11.31,17.72,17.72,0,0,1,1.69-4.39,3.65,3.65,0,0,1,1.2-1.15,1.81,1.81,0,0,1,2.16,0c1.17,1,1.09,3.37.27,4.87a12.17,12.17,0,0,1-3.36,3.35,24.93,24.93,0,0,0-7.59,12.11,4.72,4.72,0,0,0,1,4.2c.89.87,2,1.31,2.79,2.37,1,1.45,1,3.66,1.68,5.45,1,2.92,3.78,4.54,6.18,3.6a16.66,16.66,0,0,1,1.89-.83,1.61,1.61,0,0,1,1.81.63,2.87,2.87,0,0,1-.44,3.09,4.13,4.13,0,0,1-1.06.87c-.44.25-.9.44-1.35.65-.21.09-.41.2-.62.31a3.61,3.61,0,0,0-1.55,1.63,4.2,4.2,0,0,0,.86,4.3,4.76,4.76,0,0,0,3.54,1.24,27.48,27.48,0,0,1,3.74,0,1.59,1.59,0,0,1,1.45,1.16,1.67,1.67,0,0,1-.76,1.68,2.36,2.36,0,0,1-1.83-.05,9.36,9.36,0,0,0-3.74-.92,2.69,2.69,0,0,0-1.16.38,3.15,3.15,0,0,0-1.59,2.57c0,1.16.52,2.42.06,3.44a1.42,1.42,0,0,1-.56.64,1.53,1.53,0,0,1-1.68-.19,8.16,8.16,0,0,1-1.67-2.39c-.5-.86-1.17-1.69-2-1.74a1.35,1.35,0,0,0-.8.2,3.08,3.08,0,0,0-1.3,2.1,5.66,5.66,0,0,0,.72,3.6,12.2,12.2,0,0,0,4.17,3.93,9.79,9.79,0,0,1,3.9,4.32c.78,2,.39,5-1.22,5.9s-3.44-.61-4.33-2.51-1.27-4.18-2.21-6-2.72-3.2-4.24-2.32c-1.29.88-1.91,2.77-3,3.41a1.46,1.46,0,0,1-.45.18c-1.47.36-2.57-1.63-4-2.14-1.1-.39-2.17.13-3.26.76l-.42.24-.46.27a4.91,4.91,0,0,1-2.73.9c-2-.13-3.44-2.58-4.16-5s-1-5.13-2.22-7.23c-1.65-2.93-4.88-4.55-7.54-3.2-.61.31-1.24.62-1.84,1a10.24,10.24,0,0,0-3.71,3.34,12,12,0,0,1-.85,1.29,2.92,2.92,0,0,1-.72.61,2.15,2.15,0,0,1-1.14.31,2.36,2.36,0,0,1-1.79-1,3.11,3.11,0,0,1-.66-2,3,3,0,0,1,1.42-2.54,2.35,2.35,0,0,1,.43-.19,2.48,2.48,0,0,1,1.9.3,2.93,2.93,0,0,0,2.92-.06,3.51,3.51,0,0,0,.4-.27,7,7,0,0,0,2.29-3.37,8.82,8.82,0,0,0-.84-7.29c-.83-1.24-2-2-2.86-3.21a5,5,0,0,1-1-4.47c.56-1.55,2-2.06,3-3.17,1.84-2,1.73-6.25-.2-8-.6-.53-1.36-.93-1.57-1.82a1.89,1.89,0,0,1,.83-2.11,1.69,1.69,0,0,1,.7-.22c1.17-.09,2.09.91,3,1.77s1.82,1.42,2.8,1a1.42,1.42,0,0,0,.25-.12c1.15-.66,1.59-2.6,1.84-4.25S185.12,217,186.27,216.35Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.27,216.35a1.75,1.75,0,0,1,.24-.11c2.3-.92,4,3.89,6.37,3.26a1.86,1.86,0,0,0,.46-.19,5.68,5.68,0,0,0,1.26-1.16,5.86,5.86,0,0,1,1.3-1.16l.25-.13c1.17-.48,2.41.38,3.28,1.46a22.28,22.28,0,0,0,2.6,3.26,3.46,3.46,0,0,0,3.68.51,21.08,21.08,0,0,0,8.19-11.31,17.72,17.72,0,0,1,1.69-4.39,3.65,3.65,0,0,1,1.2-1.15,1.81,1.81,0,0,1,2.16,0c1.17,1,1.09,3.37.27,4.87a12.17,12.17,0,0,1-3.36,3.35,24.93,24.93,0,0,0-7.59,12.11,4.72,4.72,0,0,0,1,4.2c.89.87,2,1.31,2.79,2.37,1,1.45,1,3.66,1.68,5.45,1,2.92,3.78,4.54,6.18,3.6a16.66,16.66,0,0,1,1.89-.83,1.61,1.61,0,0,1,1.81.63,2.87,2.87,0,0,1-.44,3.09,4.13,4.13,0,0,1-1.06.87c-.44.25-.9.44-1.35.65-.21.09-.41.2-.62.31a3.61,3.61,0,0,0-1.55,1.63,4.2,4.2,0,0,0,.86,4.3,4.76,4.76,0,0,0,3.54,1.24,27.48,27.48,0,0,1,3.74,0,1.59,1.59,0,0,1,1.45,1.16,1.67,1.67,0,0,1-.76,1.68,2.36,2.36,0,0,1-1.83-.05,9.36,9.36,0,0,0-3.74-.92,2.69,2.69,0,0,0-1.16.38,3.15,3.15,0,0,0-1.59,2.57c0,1.16.52,2.42.06,3.44a1.42,1.42,0,0,1-.56.64,1.53,1.53,0,0,1-1.68-.19,8.16,8.16,0,0,1-1.67-2.39c-.5-.86-1.17-1.69-2-1.74a1.35,1.35,0,0,0-.8.2,3.08,3.08,0,0,0-1.3,2.1,5.66,5.66,0,0,0,.72,3.6,12.2,12.2,0,0,0,4.17,3.93,9.79,9.79,0,0,1,3.9,4.32c.78,2,.39,5-1.22,5.9s-3.44-.61-4.33-2.51-1.27-4.18-2.21-6-2.72-3.2-4.24-2.32c-1.29.88-1.91,2.77-3,3.41a1.46,1.46,0,0,1-.45.18c-1.47.36-2.57-1.63-4-2.14-1.1-.39-2.17.13-3.26.76l-.42.24-.46.27a4.91,4.91,0,0,1-2.73.9c-2-.13-3.44-2.58-4.16-5s-1-5.13-2.22-7.23c-1.65-2.93-4.88-4.55-7.54-3.2-.61.31-1.24.62-1.84,1a10.24,10.24,0,0,0-3.71,3.34,12,12,0,0,1-.85,1.29,2.92,2.92,0,0,1-.72.61,2.15,2.15,0,0,1-1.14.31,2.36,2.36,0,0,1-1.79-1,3.11,3.11,0,0,1-.66-2,3,3,0,0,1,1.42-2.54,2.35,2.35,0,0,1,.43-.19,2.48,2.48,0,0,1,1.9.3,2.93,2.93,0,0,0,2.92-.06,3.51,3.51,0,0,0,.4-.27,7,7,0,0,0,2.29-3.37,8.82,8.82,0,0,0-.84-7.29c-.83-1.24-2-2-2.86-3.21a5,5,0,0,1-1-4.47c.56-1.55,2-2.06,3-3.17,1.84-2,1.73-6.25-.2-8-.6-.53-1.36-.93-1.57-1.82a1.89,1.89,0,0,1,.83-2.11,1.69,1.69,0,0,1,.7-.22c1.17-.09,2.09.91,3,1.77s1.82,1.42,2.8,1a1.42,1.42,0,0,0,.25-.12c1.15-.66,1.59-2.6,1.84-4.25S185.12,217,186.27,216.35Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.22,329,55,329.51,38.74,329c-.7,11,1.44,22.15,4.39,27.6h0a7.39,7.39,0,0,0,3.22,3.27c4.79,2.77,12.53,2.77,17.29,0a7.21,7.21,0,0,0,3.22-3.35C69.8,351.06,71.91,340,71.22,329Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,322.38c6.37,3.68,6.4,9.63.08,13.3s-16.6,3.68-23,0-6.39-9.62-.07-13.3S60.06,318.71,66.42,322.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.91,323.84c5,2.87,5,7.52.06,10.38s-13,2.87-17.92,0-5-7.51-.06-10.38S58.94,321,63.91,323.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.91,323.84c5,2.87,5,7.52.06,10.38s-13,2.87-17.92,0-5-7.51-.06-10.38S58.94,321,63.91,323.84Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M46.7,295.8c-2.65-3.28-5.71-6.22-8.13-9.67-1.66-2.35-3-5.23-2.34-8a7.17,7.17,0,0,1,5.68-5,11,11,0,0,1,7.63,1.7,23.51,23.51,0,0,1,5.77,5.49,57.34,57.34,0,0,1,12.07,40.92,8.64,8.64,0,0,1-1.51,4.71A4.71,4.71,0,0,1,61,327.4c-4.43-1.31-3.84-7.29-4.56-10.8a49.27,49.27,0,0,0-5.08-13.8A49.06,49.06,0,0,0,46.7,295.8Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7,295.8c-2.65-3.28-5.71-6.22-8.13-9.67-1.66-2.35-3-5.23-2.34-8a7.17,7.17,0,0,1,5.68-5,11,11,0,0,1,7.63,1.7,23.51,23.51,0,0,1,5.77,5.49,57.34,57.34,0,0,1,12.07,40.92,8.64,8.64,0,0,1-1.51,4.71A4.71,4.71,0,0,1,61,327.4c-4.43-1.31-3.84-7.29-4.56-10.8a49.27,49.27,0,0,0-5.08-13.8A49.06,49.06,0,0,0,46.7,295.8Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.29,323a.4.4,0,0,1-.31-.37c-.31-7.1-2.62-31.33-19.32-45.09a.38.38,0,1,1,.49-.59c17,14,19.29,38.47,19.6,45.65a.38.38,0,0,1-.37.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.73,323.72a11.88,11.88,0,0,1-5.42,7.52,15.3,15.3,0,0,1-8.21,1.37,35.82,35.82,0,0,1-8.33-2c-1.34-.46-2.83-1.06-3-2.72a2.94,2.94,0,0,1,1-2.34,7.76,7.76,0,0,1,.86-.74.86.86,0,0,0-.46-1.54,21.29,21.29,0,0,1-2.37-.29,10.46,10.46,0,0,1-5-2.26,8.22,8.22,0,0,1-2.31-3.41,3.23,3.23,0,0,1,.33-3.35,3.6,3.6,0,0,1,1.85-.8c.59-.13,1.19-.24,1.78-.33a.8.8,0,0,0,.19-1.52l-2.52-1a4.7,4.7,0,0,1-1.91-1.18,4.18,4.18,0,0,1-.49-3.47c.31-1.58.85-3.1,1.23-4.66a10,10,0,0,0,.16-4.77,39.86,39.86,0,0,1,14.11.94,10.28,10.28,0,0,1,3.86,1.68c1.57,1.26,2,3.15,1.81,5.19a.36.36,0,0,0,.68.19l1.61-3a1.91,1.91,0,0,1,2.51-.8,11.48,11.48,0,0,1,3.68,2.89,6.39,6.39,0,0,1,1.57,4.71A40.51,40.51,0,0,1,59.77,315a.64.64,0,0,0,1,.68l.08-.06a2.15,2.15,0,0,1,1.52-.44c1.42.18,1.78,1.62,1.88,2.85A23.94,23.94,0,0,1,63.73,323.72Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.73,323.72a11.88,11.88,0,0,1-5.42,7.52,15.3,15.3,0,0,1-8.21,1.37,35.82,35.82,0,0,1-8.33-2c-1.34-.46-2.83-1.06-3-2.72a2.94,2.94,0,0,1,1-2.34,7.76,7.76,0,0,1,.86-.74.86.86,0,0,0-.46-1.54,21.29,21.29,0,0,1-2.37-.29,10.46,10.46,0,0,1-5-2.26,8.22,8.22,0,0,1-2.31-3.41,3.23,3.23,0,0,1,.33-3.35,3.6,3.6,0,0,1,1.85-.8c.59-.13,1.19-.24,1.78-.33a.8.8,0,0,0,.19-1.52l-2.52-1a4.7,4.7,0,0,1-1.91-1.18,4.18,4.18,0,0,1-.49-3.47c.31-1.58.85-3.1,1.23-4.66a10,10,0,0,0,.16-4.77,39.86,39.86,0,0,1,14.11.94,10.28,10.28,0,0,1,3.86,1.68c1.57,1.26,2,3.15,1.81,5.19a.36.36,0,0,0,.68.19l1.61-3a1.91,1.91,0,0,1,2.51-.8,11.48,11.48,0,0,1,3.68,2.89,6.39,6.39,0,0,1,1.57,4.71A40.51,40.51,0,0,1,59.77,315a.64.64,0,0,0,1,.68l.08-.06a2.15,2.15,0,0,1,1.52-.44c1.42.18,1.78,1.62,1.88,2.85A23.94,23.94,0,0,1,63.73,323.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.73,323.72a11.88,11.88,0,0,1-5.42,7.52,15.3,15.3,0,0,1-8.21,1.37,35.82,35.82,0,0,1-8.33-2c-1.34-.46-2.83-1.06-3-2.72a2.94,2.94,0,0,1,1-2.34,7.76,7.76,0,0,1,.86-.74.86.86,0,0,0-.46-1.54,21.29,21.29,0,0,1-2.37-.29,10.46,10.46,0,0,1-5-2.26,8.22,8.22,0,0,1-2.31-3.41,3.23,3.23,0,0,1,.33-3.35,3.6,3.6,0,0,1,1.85-.8c.59-.13,1.19-.24,1.78-.33a.8.8,0,0,0,.19-1.52l-2.52-1a4.7,4.7,0,0,1-1.91-1.18,4.18,4.18,0,0,1-.49-3.47c.31-1.58.85-3.1,1.23-4.66a10,10,0,0,0,.16-4.77,39.86,39.86,0,0,1,14.11.94,10.28,10.28,0,0,1,3.86,1.68c1.57,1.26,2,3.15,1.81,5.19a.36.36,0,0,0,.68.19l1.61-3a1.91,1.91,0,0,1,2.51-.8,11.48,11.48,0,0,1,3.68,2.89,6.39,6.39,0,0,1,1.57,4.71A40.51,40.51,0,0,1,59.77,315a.64.64,0,0,0,1,.68l.08-.06a2.15,2.15,0,0,1,1.52-.44c1.42.18,1.78,1.62,1.88,2.85A23.94,23.94,0,0,1,63.73,323.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25,330.85a56.69,56.69,0,0,0-3.8-11,.37.37,0,0,0-.13-.29l-.26-.57a35.81,35.81,0,0,1,3.75-12.6.38.38,0,0,0-.14-.53.4.4,0,0,0-.53.15,36.25,36.25,0,0,0-3.7,11.7c-3.21-6.44-8.34-14-16.25-19.48a.39.39,0,0,0-.54.09.39.39,0,0,0,.1.54c8.16,5.68,13.31,13.56,16.44,20.09a23.63,23.63,0,0,0-13.46-1.82.39.39,0,0,0,0,.76h.15c.07,0,7.46-1.36,13.84,2.21A56.67,56.67,0,0,1,55.49,331a.38.38,0,0,0,.31.3H56A.38.38,0,0,0,56.25,330.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.35,307.68l-17.11.5-17.12-.5c-.74,11.56,1.52,23.33,4.63,29.09h0a7.78,7.78,0,0,0,3.39,3.44c5.05,2.92,13.21,2.92,18.23,0a7.62,7.62,0,0,0,3.39-3.53C450.85,330.89,453.08,319.18,452.35,307.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.3,300.67c6.7,3.87,6.74,10.15.08,14s-17.5,3.87-24.21,0-6.74-10.15-.07-14S440.59,296.8,447.3,300.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.65,302.21c5.23,3,5.26,7.92.06,10.94s-13.65,3-18.88,0-5.26-7.92-.07-10.94S439.42,299.19,444.65,302.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444.65,302.21c5.23,3,5.26,7.92.06,10.94s-13.65,3-18.88,0-5.26-7.92-.07-10.94S439.42,299.19,444.65,302.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M463.37,234.65c-38.56,12.63-38.91,38.43-30.22,56.8,2.19,3.72,8.83,5.72,14.61-17.13l-10.13,1.3,11.8-6,3.07-9.16-9.84.73,12.49-5.26A184.87,184.87,0,0,1,463.37,234.65Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.37,234.65c-38.56,12.63-38.91,38.43-30.22,56.8,2.19,3.72,8.83,5.72,14.61-17.13l-10.13,1.3,11.8-6,3.07-9.16-9.84.73,12.49-5.26A184.87,184.87,0,0,1,463.37,234.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.37,234.65c-38.56,12.63-38.91,38.43-30.22,56.8,2.19,3.72,8.83,5.72,14.61-17.13l-10.13,1.3,11.8-6,3.07-9.16-9.84.73,12.49-5.26A184.87,184.87,0,0,1,463.37,234.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.47,241.1c-20.34,15.44-22.18,33.13-16.43,51.61C434,276.44,431.81,260,452.47,241.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.05,260.86c38,5.35,42.63,29.32,37.58,47.88-1.42,3.83-7.27,6.79-16.44-13.53l9.65-.48-12-3.61-4.38-8,9.29-1-12.51-2.82A174.38,174.38,0,0,0,398.05,260.86Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.05,260.86c38,5.35,42.63,29.32,37.58,47.88-1.42,3.83-7.27,6.79-16.44-13.53l9.65-.48-12-3.61-4.38-8,9.29-1-12.51-2.82A174.38,174.38,0,0,0,398.05,260.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.05,260.86c38,5.35,42.63,29.32,37.58,47.88-1.42,3.83-7.27,6.79-16.44-13.53l9.65-.48-12-3.61-4.38-8,9.29-1-12.51-2.82A174.38,174.38,0,0,0,398.05,260.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.28,265.06c21.51,11,26.16,27.17,23.88,45.33C432.35,294.9,431.66,279.22,409.28,265.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.5,269.84c-34.86.57-41.7,21.66-39.23,39,.85,3.61,5.79,6.94,16.34-10.35L443,296.93,454.17,295l4.85-6.75-8.27-1.9,11.59-1.14A159.81,159.81,0,0,1,474.5,269.84Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.91,272.37c-20.62,7.5-26.62,21.56-26.59,38.19C439.78,296.69,442.15,282.63,463.91,272.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.5,269.84c-34.86.57-41.7,21.66-39.23,39,.85,3.61,5.79,6.94,16.34-10.35L443,296.93,454.17,295l4.85-6.75-8.27-1.9,11.59-1.14A159.81,159.81,0,0,1,474.5,269.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-cans--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.22,333.45a13.66,13.66,0,0,1,1,1.29A13.66,13.66,0,0,0,139.22,333.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,333.33a19.9,19.9,0,0,1,4.86-3.83A19.9,19.9,0,0,0,90.66,333.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.22,329.5c.67.38,1.3.79,1.89,1.2C135.52,330.29,134.89,329.88,134.22,329.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32,334.84a11.42,11.42,0,0,1,.82,1.36A11.42,11.42,0,0,0,140.32,334.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.86,332.1a16.58,16.58,0,0,1,1.27,1.24A16.58,16.58,0,0,0,137.86,332.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.69,339.19a11.37,11.37,0,0,1,2.7-5.52A11.37,11.37,0,0,0,87.69,339.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.29,330.85c.51.37,1,.74,1.45,1.13C137.29,331.59,136.8,331.22,136.29,330.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.57,340.71a9.11,9.11,0,0,1,.12-1.47A9.11,9.11,0,0,0,87.57,340.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.11,330.7l.18.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39,333.67c.09-.11.17-.23.27-.34C90.56,333.44,90.48,333.56,90.39,333.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.69,339.24v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7,341.7c9.44-5.49,24.86-5.48,34.36,0a16.91,16.91,0,0,1,5.25,4.52c3.73-5.12,2-11.29-5.25-15.46-9.5-5.49-24.92-5.49-34.36,0-7.15,4.15-8.84,10.27-5.14,15.38A16.58,16.58,0,0,1,97.7,341.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.81,350.66c9.5,5.49,24.92,5.49,34.37,0a16.29,16.29,0,0,0,5.13-4.44,16.91,16.91,0,0,0-5.25-4.52c-9.5-5.48-24.92-5.49-34.36,0a16.58,16.58,0,0,0-5.14,4.44A16.91,16.91,0,0,0,97.81,350.66Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.81,350.66c9.5,5.49,24.92,5.49,34.37,0a16.29,16.29,0,0,0,5.13-4.44,16.91,16.91,0,0,0-5.25-4.52c-9.5-5.48-24.92-5.49-34.36,0a16.58,16.58,0,0,0-5.14,4.44A16.91,16.91,0,0,0,97.81,350.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.81,350.66c9.5,5.49,24.92,5.49,34.37,0a16.29,16.29,0,0,0,5.13-4.44,16.91,16.91,0,0,0-5.25-4.52c-9.5-5.48-24.92-5.49-34.36,0a16.58,16.58,0,0,0-5.14,4.44A16.91,16.91,0,0,0,97.81,350.66Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.74,332l.12.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.14,336.2l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,340.72h0c0,4.06-2.63,8.11-7.94,11.2-10.64,6.18-28,6.19-38.73,0-5.35-3.09-8-7.15-8.06-11.21h0v51.45h0c0,4.06,2.71,8.12,8.06,11.21,10.72,6.19,28.09,6.18,38.73,0,5.31-3.09,8-7.14,7.94-11.2h0V340.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.26,334.74l.06.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.13,333.34l.09.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.63,351.92c10.72,6.19,28.09,6.18,38.73,0,5.31-3.09,8-7.14,7.94-11.2a9.94,9.94,0,0,0-1.14-4.49l0,0a11.42,11.42,0,0,0-.82-1.36l-.06-.1a13.66,13.66,0,0,0-1-1.29l-.09-.11a16.58,16.58,0,0,0-1.27-1.24l-.12-.12c-.45-.39-.94-.76-1.45-1.13l-.18-.15c-.59-.41-1.22-.82-1.89-1.2-10.7-6.18-28.07-6.18-38.7,0a19.9,19.9,0,0,0-4.86,3.83c-.1.11-.18.23-.27.34a11.37,11.37,0,0,0-2.7,5.52v.05a9.11,9.11,0,0,0-.12,1.47C87.59,344.77,90.28,348.83,95.63,351.92Zm2.07-21.16c9.44-5.49,24.86-5.49,34.36,0s9.56,14.41.12,19.9-24.87,5.49-34.37,0S88.25,336.24,97.7,330.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.41,339.9a13.19,13.19,0,0,1,.84,1A13.19,13.19,0,0,0,406.41,339.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.5,339.81a16.2,16.2,0,0,1,3.89-3.07A16.2,16.2,0,0,0,367.5,339.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.41,336.74c.53.31,1,.63,1.51,1C403.45,337.37,402.94,337.05,402.41,336.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.29,341a9.59,9.59,0,0,1,.66,1.09A9.59,9.59,0,0,0,407.29,341Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.32,338.82c.36.33.71.65,1,1C406,339.47,405.68,339.15,405.32,338.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.12,344.5a9.16,9.16,0,0,1,2.17-4.42A9.16,9.16,0,0,0,365.12,344.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.06,337.82a13.92,13.92,0,0,1,1.17.91A13.92,13.92,0,0,0,404.06,337.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,345.72a7.91,7.91,0,0,1,.09-1.18A7.91,7.91,0,0,0,365,345.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.92,337.7l.14.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.29,340.08c.07-.09.13-.18.21-.27C367.42,339.9,367.36,340,367.29,340.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.12,344.54v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.14,346.51c7.57-4.39,19.92-4.39,27.53,0a13.46,13.46,0,0,1,4.21,3.63c3-4.11,1.59-9.05-4.21-12.39-7.61-4.4-20-4.4-27.53,0-5.72,3.32-7.08,8.23-4.11,12.32A13.33,13.33,0,0,1,373.14,346.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,353.69c7.62,4.4,20,4.4,27.54,0a13.33,13.33,0,0,0,4.11-3.56,13.46,13.46,0,0,0-4.21-3.63c-7.61-4.39-20-4.39-27.53,0a13.33,13.33,0,0,0-4.11,3.56A13.27,13.27,0,0,0,373.23,353.69Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,353.69c7.62,4.4,20,4.4,27.54,0a13.33,13.33,0,0,0,4.11-3.56,13.46,13.46,0,0,0-4.21-3.63c-7.61-4.39-20-4.39-27.53,0a13.33,13.33,0,0,0-4.11,3.56A13.27,13.27,0,0,0,373.23,353.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,353.69c7.62,4.4,20,4.4,27.54,0a13.33,13.33,0,0,0,4.11-3.56,13.46,13.46,0,0,0-4.21-3.63c-7.61-4.39-20-4.39-27.53,0a13.33,13.33,0,0,0-4.11,3.56A13.27,13.27,0,0,0,373.23,353.69Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.23,338.73l.09.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,342.11s0,0,0,0S408,342.11,408,342.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.88,345.73h0c0,3.25-2.11,6.5-6.36,9-8.53,5-22.45,5-31,0-4.29-2.47-6.44-5.72-6.46-9h0v41.22h0c0,3.26,2.17,6.51,6.46,9,8.58,5,22.5,4.95,31,0,4.25-2.48,6.37-5.73,6.36-9h0V345.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.25,340.94s0,.05,0,.08S407.26,341,407.25,340.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.34,339.81l.07.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.49,354.7c8.58,5,22.5,5,31,0,4.25-2.47,6.37-5.72,6.36-9a8,8,0,0,0-.92-3.6s0,0,0,0a9.59,9.59,0,0,0-.66-1.09s0,0,0-.08a13.19,13.19,0,0,0-.84-1l-.07-.09c-.31-.34-.66-.66-1-1l-.09-.09a13.92,13.92,0,0,0-1.17-.91l-.14-.12c-.47-.33-1-.65-1.51-1-8.58-5-22.49-5-31,0a16.2,16.2,0,0,0-3.89,3.07c-.08.09-.14.18-.21.27a9.16,9.16,0,0,0-2.17,4.42v0a7.91,7.91,0,0,0-.09,1.18C365.05,349,367.2,352.23,371.49,354.7Zm1.65-16.95c7.57-4.4,19.92-4.4,27.53,0s7.67,11.55.1,15.95-19.92,4.39-27.54,0S365.57,342.14,373.14,337.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,385.5c.16.19.32.38.46.57C161.33,385.88,161.17,385.69,161,385.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57,385.45a8.6,8.6,0,0,1,2.14-1.69A8.6,8.6,0,0,0,139.57,385.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,383.76c.3.17.57.35.83.53C159.37,384.11,159.1,383.93,158.8,383.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.49,386.12a4.6,4.6,0,0,1,.37.6A4.6,4.6,0,0,0,161.49,386.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.41,384.91a5.64,5.64,0,0,1,.55.54A5.64,5.64,0,0,0,160.41,384.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.25,388a5,5,0,0,1,1.2-2.44A5,5,0,0,0,138.25,388Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.71,384.35a6.82,6.82,0,0,1,.64.51A6.82,6.82,0,0,0,159.71,384.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.2,388.71a4.74,4.74,0,0,1,.05-.65A4.74,4.74,0,0,0,138.2,388.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.63,384.29l.08.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.45,385.6a1.58,1.58,0,0,1,.12-.15A1.58,1.58,0,0,0,139.45,385.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.25,388.06v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,389.15a16.7,16.7,0,0,1,15.17,0,7.27,7.27,0,0,1,2.32,2c1.65-2.26.88-5-2.32-6.83a16.76,16.76,0,0,0-15.17,0c-3.15,1.84-3.9,4.54-2.26,6.8A7,7,0,0,1,142.67,389.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,393.1c4.2,2.42,11,2.43,15.18,0a7.26,7.26,0,0,0,2.26-2,7.27,7.27,0,0,0-2.32-2,16.7,16.7,0,0,0-15.17,0,7,7,0,0,0-2.26,2A7.34,7.34,0,0,0,142.72,393.1Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,393.1c4.2,2.42,11,2.43,15.18,0a7.26,7.26,0,0,0,2.26-2,7.27,7.27,0,0,0-2.32-2,16.7,16.7,0,0,0-15.17,0,7,7,0,0,0-2.26,2A7.34,7.34,0,0,0,142.72,393.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72,393.1c4.2,2.42,11,2.43,15.18,0a7.26,7.26,0,0,0,2.26-2,7.27,7.27,0,0,0-2.32-2,16.7,16.7,0,0,0-15.17,0,7,7,0,0,0-2.26,2A7.34,7.34,0,0,0,142.72,393.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.35,384.86l.06.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.86,386.72h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36,388.71h0c0,1.79-1.15,3.59-3.5,5-4.7,2.73-12.37,2.73-17.1,0-2.36-1.37-3.55-3.16-3.56-5h0v22.72h0c0,1.79,1.2,3.58,3.56,4.95,4.73,2.73,12.4,2.72,17.1,0,2.35-1.37,3.51-3.16,3.5-4.95h0V388.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.47,386.07l0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,385.45l0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76,393.66c4.73,2.73,12.4,2.73,17.1,0,2.35-1.36,3.51-3.16,3.5-5a4.34,4.34,0,0,0-.5-2h0a4.6,4.6,0,0,0-.37-.6l0-.05c-.14-.19-.3-.38-.46-.57l0-.05a5.64,5.64,0,0,0-.55-.54l-.06-.05a6.82,6.82,0,0,0-.64-.51l-.08-.06c-.26-.18-.53-.36-.83-.53-4.73-2.73-12.39-2.73-17.09,0a8.6,8.6,0,0,0-2.14,1.69,1.58,1.58,0,0,0-.12.15,5,5,0,0,0-1.2,2.44v0a4.74,4.74,0,0,0-.05.65C138.21,390.5,139.4,392.29,141.76,393.66Zm.91-9.35a16.76,16.76,0,0,1,15.17,0c4.2,2.43,4.23,6.37.06,8.79s-11,2.42-15.18,0S138.5,386.74,142.67,384.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76,393.66c4.73,2.73,12.4,2.73,17.1,0,2.35-1.36,3.51-3.16,3.5-5a4.34,4.34,0,0,0-.5-2h0a4.6,4.6,0,0,0-.37-.6l0-.05c-.14-.19-.3-.38-.46-.57l0-.05a5.64,5.64,0,0,0-.55-.54l-.06-.05a6.82,6.82,0,0,0-.64-.51l-.08-.06c-.26-.18-.53-.36-.83-.53-4.73-2.73-12.39-2.73-17.09,0a8.6,8.6,0,0,0-2.14,1.69,1.58,1.58,0,0,0-.12.15,5,5,0,0,0-1.2,2.44v0a4.74,4.74,0,0,0-.05.65C138.21,390.5,139.4,392.29,141.76,393.66Zm.91-9.35a16.76,16.76,0,0,1,15.17,0c4.2,2.43,4.23,6.37.06,8.79s-11,2.42-15.18,0S138.5,386.74,142.67,384.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.48,317.73a7.83,7.83,0,0,1,.54.66A7.83,7.83,0,0,0,270.48,317.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.6,317.67a10.08,10.08,0,0,1,2.49-2A10.08,10.08,0,0,0,245.6,317.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.92,315.7c.35.2.67.41,1,.62C268.59,316.11,268.27,315.9,267.92,315.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.05,318.44a5.64,5.64,0,0,1,.42.7A5.64,5.64,0,0,0,271.05,318.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.79,317c.23.21.45.42.65.63C270.24,317.46,270,317.25,269.79,317Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.07,320.67a5.84,5.84,0,0,1,1.39-2.82A5.84,5.84,0,0,0,244.07,320.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,316.4c.26.19.52.38.75.58C269.5,316.78,269.24,316.59,269,316.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,321.45a4.74,4.74,0,0,1,.06-.75A4.74,4.74,0,0,0,244,321.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.89,316.32l.09.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,317.85a2.2,2.2,0,0,1,.14-.18A2.2,2.2,0,0,0,245.46,317.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.07,320.7v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2,322c4.84-2.81,12.74-2.81,17.61,0a8.34,8.34,0,0,1,2.69,2.32c1.91-2.63,1-5.79-2.69-7.93-4.87-2.81-12.77-2.81-17.61,0-3.66,2.13-4.53,5.27-2.63,7.88A8.44,8.44,0,0,1,249.2,322Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,326.55c4.87,2.81,12.77,2.82,17.61,0a8.44,8.44,0,0,0,2.63-2.27,8.34,8.34,0,0,0-2.69-2.32c-4.87-2.81-12.77-2.81-17.61,0a8.44,8.44,0,0,0-2.63,2.27A8.45,8.45,0,0,0,249.26,326.55Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,326.55c4.87,2.81,12.77,2.82,17.61,0a8.44,8.44,0,0,0,2.63-2.27,8.34,8.34,0,0,0-2.69-2.32c-4.87-2.81-12.77-2.81-17.61,0a8.44,8.44,0,0,0-2.63,2.27A8.45,8.45,0,0,0,249.26,326.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,326.55c4.87,2.81,12.77,2.82,17.61,0a8.44,8.44,0,0,0,2.63-2.27,8.34,8.34,0,0,0-2.69-2.32c-4.87-2.81-12.77-2.81-17.61,0a8.44,8.44,0,0,0-2.63,2.27A8.45,8.45,0,0,0,249.26,326.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.73,317l.06.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.47,319.14v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.06,321.46h0c0,2.08-1.34,4.16-4.07,5.75-5.45,3.16-14.35,3.17-19.85,0-2.74-1.59-4.12-3.67-4.13-5.75h0v26.37h0c0,2.08,1.39,4.16,4.13,5.75,5.5,3.17,14.4,3.16,19.85,0,2.73-1.59,4.08-3.67,4.07-5.75h0V321.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,318.39l0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.44,317.67l0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14,327.2c5.5,3.17,14.4,3.16,19.85,0,2.73-1.59,4.08-3.67,4.07-5.75a5,5,0,0,0-.58-2.29v0a5.64,5.64,0,0,0-.42-.7l0-.05a7.83,7.83,0,0,0-.54-.66l0-.06c-.2-.21-.42-.42-.65-.63l-.06-.06c-.23-.2-.49-.39-.75-.58l-.09-.08c-.3-.21-.62-.42-1-.62-5.48-3.16-14.38-3.16-19.83,0a10.08,10.08,0,0,0-2.49,2,2.2,2.2,0,0,0-.14.18,5.84,5.84,0,0,0-1.39,2.82v0a4.74,4.74,0,0,0-.06.75C244,323.53,245.4,325.61,248.14,327.2Zm1.06-10.85c4.84-2.81,12.74-2.81,17.61,0s4.9,7.39.06,10.2-12.74,2.81-17.61,0S244.36,319.16,249.2,316.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14,327.2c5.5,3.17,14.4,3.16,19.85,0,2.73-1.59,4.08-3.67,4.07-5.75a5,5,0,0,0-.58-2.29v0a5.64,5.64,0,0,0-.42-.7l0-.05a7.83,7.83,0,0,0-.54-.66l0-.06c-.2-.21-.42-.42-.65-.63l-.06-.06c-.23-.2-.49-.39-.75-.58l-.09-.08c-.3-.21-.62-.42-1-.62-5.48-3.16-14.38-3.16-19.83,0a10.08,10.08,0,0,0-2.49,2,2.2,2.2,0,0,0-.14.18,5.84,5.84,0,0,0-1.39,2.82v0a4.74,4.74,0,0,0-.06.75C244,323.53,245.4,325.61,248.14,327.2Zm1.06-10.85c4.84-2.81,12.74-2.81,17.61,0s4.9,7.39.06,10.2-12.74,2.81-17.61,0S244.36,319.16,249.2,316.35Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.82,407a11.38,11.38,0,0,0,8.53,3.14,25.74,25.74,0,0,0,9-2.28c2.89-1.18,6.51-4.5,9.63-4.44a73,73,0,0,0,9.12-.63,47.69,47.69,0,0,0-1.29-12.36L273.27,390c-3.93,5.39-11.58,9.87-17.37,11.55a5.11,5.11,0,0,0-3.59,3.83s0,.06,0,.09A6.56,6.56,0,0,0,252.82,407Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,403.39c-3.12-.06-6.74,3.26-9.63,4.44a25.74,25.74,0,0,1-9,2.28,11.38,11.38,0,0,1-8.53-3.14,6.56,6.56,0,0,1-.5-1.48s0-.06,0-.09a4.54,4.54,0,0,0,0,1.94,6.56,6.56,0,0,0,.5,1.48,11.38,11.38,0,0,0,8.53,3.14,25.74,25.74,0,0,0,9-2.28c2.89-1.18,6.51-4.5,9.63-4.44a69,69,0,0,0,9-.52c.07-.65.12-1.3.14-2A73,73,0,0,1,280,403.39Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.82,407a11.38,11.38,0,0,0,8.53,3.14,25.74,25.74,0,0,0,9-2.28c2.89-1.18,6.51-4.5,9.63-4.44a73,73,0,0,0,9.12-.63,47.69,47.69,0,0,0-1.29-12.36L273.27,390c-3.93,5.39-11.58,9.87-17.37,11.55a5.11,5.11,0,0,0-3.59,3.83s0,.06,0,.09A6.56,6.56,0,0,0,252.82,407Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.82,407a11.38,11.38,0,0,0,8.53,3.14,25.74,25.74,0,0,0,9-2.28c2.89-1.18,6.51-4.5,9.63-4.44a73,73,0,0,0,9.12-.63,47.69,47.69,0,0,0-1.29-12.36L273.27,390c-3.93,5.39-11.58,9.87-17.37,11.55a5.11,5.11,0,0,0-3.59,3.83s0,.06,0,.09A6.56,6.56,0,0,0,252.82,407Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,403.39c-3.12-.06-6.74,3.26-9.63,4.44a25.74,25.74,0,0,1-9,2.28,11.38,11.38,0,0,1-8.53-3.14,6.56,6.56,0,0,1-.5-1.48s0-.06,0-.09a4.54,4.54,0,0,0,0,1.94,6.56,6.56,0,0,0,.5,1.48,11.38,11.38,0,0,0,8.53,3.14,25.74,25.74,0,0,0,9-2.28c2.89-1.18,6.51-4.5,9.63-4.44a69,69,0,0,0,9-.52c.07-.65.12-1.3.14-2A73,73,0,0,1,280,403.39Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.89,415.09a22.89,22.89,0,0,1-.47,4.74,11,11,0,0,1-4.33,6.91,13.89,13.89,0,0,1-6.89,1.83,15.21,15.21,0,0,1-6.3-.65,7.14,7.14,0,0,1-3.69-3s0,.06,0,.08a6.58,6.58,0,0,0,4.24,4.42,15.21,15.21,0,0,0,6.3.65,13.89,13.89,0,0,0,6.89-1.83,11,11,0,0,0,4.33-6.91,22.25,22.25,0,0,0,.47-4.75,8,8,0,0,1,2.54-5.79c.39-.37.77-.75,1.11-1.14a2.84,2.84,0,0,0,.68-2.07c0-.29-.06-.58-.09-.87-.58.67-1.93,2.27-2.27,2.59A8,8,0,0,0,324.89,415.09Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,398.57a17.26,17.26,0,0,1-1.21,9.61,37.18,37.18,0,0,1-5.09,8.37,23.81,23.81,0,0,0-2.66,3.88,7,7,0,0,0-.76,4.48,7.14,7.14,0,0,0,3.69,3,15.21,15.21,0,0,0,6.3.65,13.89,13.89,0,0,0,6.89-1.83,11,11,0,0,0,4.33-6.91,22.89,22.89,0,0,0,.47-4.74,8,8,0,0,1,2.54-5.8c.34-.32,1.69-1.92,2.27-2.59a17.65,17.65,0,0,0-2.34-6.7Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.89,415.09a22.89,22.89,0,0,1-.47,4.74,11,11,0,0,1-4.33,6.91,13.89,13.89,0,0,1-6.89,1.83,15.21,15.21,0,0,1-6.3-.65,7.14,7.14,0,0,1-3.69-3s0,.06,0,.08a6.58,6.58,0,0,0,4.24,4.42,15.21,15.21,0,0,0,6.3.65,13.89,13.89,0,0,0,6.89-1.83,11,11,0,0,0,4.33-6.91,22.25,22.25,0,0,0,.47-4.75,8,8,0,0,1,2.54-5.79c.39-.37.77-.75,1.11-1.14a2.84,2.84,0,0,0,.68-2.07c0-.29-.06-.58-.09-.87-.58.67-1.93,2.27-2.27,2.59A8,8,0,0,0,324.89,415.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,398.57a17.26,17.26,0,0,1-1.21,9.61,37.18,37.18,0,0,1-5.09,8.37,23.81,23.81,0,0,0-2.66,3.88,7,7,0,0,0-.76,4.48,7.14,7.14,0,0,0,3.69,3,15.21,15.21,0,0,0,6.3.65,13.89,13.89,0,0,0,6.89-1.83,11,11,0,0,0,4.33-6.91,22.89,22.89,0,0,0,.47-4.74,8,8,0,0,1,2.54-5.8c.34-.32,1.69-1.92,2.27-2.59a17.65,17.65,0,0,0-2.34-6.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,398.57a17.26,17.26,0,0,1-1.21,9.61,37.18,37.18,0,0,1-5.09,8.37,23.81,23.81,0,0,0-2.66,3.88,7,7,0,0,0-.76,4.48,7.14,7.14,0,0,0,3.69,3,15.21,15.21,0,0,0,6.3.65,13.89,13.89,0,0,0,6.89-1.83,11,11,0,0,0,4.33-6.91,22.89,22.89,0,0,0,.47-4.74,8,8,0,0,1,2.54-5.8c.34-.32,1.69-1.92,2.27-2.59a17.65,17.65,0,0,0-2.34-6.7Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66,262.3s-3.68,48.39-3.36,61.85S271,390.81,271,390.81c7.54,4.41,18.44,1.12,18.44,1.12.88-42.46,4.88-51.59,2.16-67.14,1.92-11.53,4.57-38.42,4.57-38.42,3.76,32.34,6.49,49,6.49,49l9,64.73c7.37,3.85,16.66,0,16.66,0,0-36.9.8-52.5-3-76.86-.21-37.49-2.1-60.27-2.1-60.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.57,274.8c2.58,6.3,10.64,6.3,10.64,6.3l1.44,7.17-.53,25.49c1.55-12.4,3-27.39,3-27.39l-1-7.67A21.28,21.28,0,0,1,281.57,274.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,193.69l-7.46,2.13-8.37-28.37a13.13,13.13,0,0,1-.27-6.7l.84-3.83a10,10,0,0,0,.22-3c-.11-1.55-.27-3.13-.34-4.64a2.2,2.2,0,0,0-.35-1.34,1.34,1.34,0,0,0-1.51-.32,2.17,2.17,0,0,0-1.12,1.15,6.07,6.07,0,0,0-.44,1.58l-.48,2.5a3.49,3.49,0,0,1-.31,1,1.13,1.13,0,0,1-.82.61c-.8.07-5.67-12.47-5.32-17,.09-1.21-3.37-2.16-3.45,2.89a3.21,3.21,0,0,0-2.15,1.83c-.6,1.1-1.2,2.19-1.81,3.28a13.76,13.76,0,0,0-1.48,3.36,11.07,11.07,0,0,0,.36,5.44,22.69,22.69,0,0,0,4.72,8.68,13.35,13.35,0,0,1,3,6.77l5.16,33.39a11,11,0,0,0,13.35,9.23L247.31,210Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5,186.45c-7.57-1.86-14,.05-20.47,2s-15.32,4.91-15.32,4.91a18.68,18.68,0,0,0,2.92,17.68l25.87-3.94Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5,186.45c-7.57-1.86-14,.05-20.47,2s-15.32,4.91-15.32,4.91a18.68,18.68,0,0,0,2.92,17.68l25.87-3.94Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42,266s-29.27,10.71-53-2.64c0,0,1.44-17,1.87-26.95s-3-29.09-3.51-34.23.17-14,6.23-15.38c11.23-2.37,32.34,0,32.34,0l12.6,13.93C326.22,227.91,325.32,256.47,324.42,266Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.42,266s-29.27,10.71-53-2.64c0,0,1.44-17,1.87-26.95s-3-29.09-3.51-34.23.17-14,6.23-15.38c11.23-2.37,32.34,0,32.34,0l12.6,13.93C326.22,227.91,325.32,256.47,324.42,266Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,164.73a10.76,10.76,0,0,1-1.13-14.47,5.9,5.9,0,0,1-2.47-3,3.13,3.13,0,0,1,4.57-3.62,4.4,4.4,0,0,1,2.41-4.86,4.15,4.15,0,0,1,5,1.61,2.81,2.81,0,0,1,2.26-2.49,5.68,5.68,0,0,1,3.52.69c1.09.54,2.09,1.24,3.19,1.76a26.07,26.07,0,0,0,5.95,1.56,12.16,12.16,0,0,1,5.63,2.31c1.57,1.33,2.74,4.12,1.53,6.23a3.36,3.36,0,0,1,2.59-1,3.23,3.23,0,0,1,2.35,1.38c-1.37.62-2.71,1.31-4.09,1.93,1.36-.41,3.15.74,3.68,2a7.73,7.73,0,0,1,.15,4.19,55.39,55.39,0,0,1-4.85,15.32c-1.21,2.5-2.83,5.11-5.47,6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.37,179.77l.56,6.3a2.35,2.35,0,0,1-.35,1.39,3.57,3.57,0,0,0,.55,4.12,4.68,4.68,0,0,0,2.82,1,13.65,13.65,0,0,0,10.42-4,3,3,0,0,0,.82-2.16l-.41-16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.51,171.2l-13.14,8.57.5,5.59c3.05-.72,6.13-1.6,8.55-3.56A11.74,11.74,0,0,0,297.51,171.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,151.75a56.41,56.41,0,0,0-1.42,21.87,17,17,0,0,0,1.14,4.68,7.17,7.17,0,0,0,3.11,3.58c1.75.93,3.84.87,5.81.78,3.62-.17,7.34-.35,10.65-1.81s6.2-4.5,6.36-8.12a6.23,6.23,0,0,0,5.84,1.09,6.32,6.32,0,0,0,3.87-4.56c.4-2-.47-4.37-2.39-5a4.32,4.32,0,0,0-3.55.56,12.42,12.42,0,0,0-2.75,2.47,4.3,4.3,0,0,1-1.36,1.12,1.45,1.45,0,0,1-1.64-.23,2.16,2.16,0,0,1-.23-1.85l.8-4.51a1.84,1.84,0,0,0-.79-1.82,4.52,4.52,0,0,1-1.73-2.61,9.39,9.39,0,0,1-.22-2.8,1.13,1.13,0,0,0-1.4-1.16C285.63,155.07,278,154.19,272,151.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.5 164.06 275.52 170.4 280.27 171.95 280.5 164.06",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.65,174.93l-3.93,1.31a2.45,2.45,0,0,0,2.7,1.17A2.2,2.2,0,0,0,284.65,174.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.65,174.93l-3.93,1.31a2.45,2.45,0,0,0,2.7,1.17A2.2,2.2,0,0,0,284.65,174.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.12,177.36a2.23,2.23,0,0,0,1.3,0,2,2,0,0,0,1.24-1.82,2.31,2.31,0,0,0-1.52.31A2.38,2.38,0,0,0,282.12,177.36Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.51,164.1a1.41,1.41,0,1,1-1.37-1.45A1.41,1.41,0,0,1,287.51,164.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38,162.54a1.41,1.41,0,1,1-1.37-1.45A1.41,1.41,0,0,1,276.38,162.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.81,158.37l-3.67,1a2,2,0,0,1,1.32-1.88A2.38,2.38,0,0,1,276.81,158.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.29,159.66l3.38,1.72a2,2,0,0,0-.9-2.11A2.37,2.37,0,0,0,285.29,159.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.56,274.74l19-33.31a13.39,13.39,0,0,0,.34-11.21L330.32,205.4a32.33,32.33,0,0,0-18.39-17.61l-3.61-1c-1.52,14.89,3.93,22.09,17.56,48,0,0-7.18,24.12-12.79,34.84a40.8,40.8,0,0,0-12,8.71,2.18,2.18,0,0,0-.12,2.86l0,0a2,2,0,0,0,2.51.54c1.83-.94,3.64-1.91,5.48-2.84a59.48,59.48,0,0,1-7.12,11.79,2.23,2.23,0,0,0,.14,2.9l0,0a2.26,2.26,0,0,0,2,.68l5.94-.88a10.7,10.7,0,0,0,8.07-5.9A36.64,36.64,0,0,0,321.56,274.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.32,186.77c14.47.7,19,6.62,28.2,31.49-4.58,7.09-17.22,6.14-17.22,6.14C302.88,199.61,308.32,186.77,308.32,186.77Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.32,186.77c14.47.7,19,6.62,28.2,31.49-4.58,7.09-17.22,6.14-17.22,6.14C302.88,199.61,308.32,186.77,308.32,186.77Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,183.47,228,182.09l-9.79-1.39c-15.76,58-31.12,228.05-22.45,229.28S236.87,243.56,237.82,183.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.72,184.23c2.33-16.45,5.73-63,5.73-63L237,120l-8.44-1.19S219,164.52,216.67,181h0c-.24,1.71.65,3.57,2.72,5.19,4.13,3.23,11.41,4.26,16.25,2.3,2.42-1,3.77-2.53,4-4.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.53,188c0-.22,0-.43,0-.65h0c2.33-16.45,10.89-67.83,10.89-67.83l-2.85-.4s-9.16,49.18-11.72,66.65c.16.14.32.29.5.43A13.91,13.91,0,0,0,222.53,188Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,188.71c2.33-16.45,8.25-68.21,8.25-68.21l-1.41-.2s-6.46,51.68-8.79,68.13h0c0,.34-.12.68-.19,1a16.36,16.36,0,0,0,2-.15c0-.2.1-.39.13-.59Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,119.89l-1.15-.16-.29,0s-8.06,51.45-10.39,67.9c-.05.35-.07.7-.1,1,.62.18,1.25.33,1.89.46q.06-.61.15-1.23C228.79,171.41,236.35,119.89,236.35,119.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.36,124a13.71,13.71,0,0,1-6.43-2.53A5.37,5.37,0,0,1,228,119l-.17-.53h-.13a22.13,22.13,0,0,1,1.72-23.83c3-4,7.42-6.9,11.66-9.69l3-2c3.92-2.68,8.46-6.26,11-11.14.67,7.95,1.29,15.46.58,23.25-1.12,12.25-4.45,21-10.17,26.85l-.11.11a6,6,0,0,1-2.1,1.35A13.58,13.58,0,0,1,236.36,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.83,90.4c.53.5,1.34.61,1.85,1.12.79.8.48,2.17-.14,3.11a12.45,12.45,0,0,0-1.86,2.79,3.08,3.08,0,0,0,5,3.26,9.93,9.93,0,0,0,1.44-2A2.93,2.93,0,0,1,244,97.34a2.32,2.32,0,0,1,2.27,1.6,5.41,5.41,0,0,1,0,3,14.23,14.23,0,0,0-.45,3,3.06,3.06,0,0,0,1.26,2.58,2.74,2.74,0,0,0,3.36-.72,4.83,4.83,0,0,0,.95-3.51,23,23,0,0,0-.76-3.65,8,8,0,0,1-.16-3.7,2.48,2.48,0,0,1,.73-1.32,1.35,1.35,0,0,1,1.43-.27c.68.33.81,1.23.91,2s.43,1.66,1.19,1.74a1.26,1.26,0,0,0,1.08-.56,3.9,3.9,0,0,0,.5-1.17l.06-.23.09-.91c.71-7.79.1-15.43-.56-23.19a.94.94,0,0,0-1.75-.38c-2.34,4.38-6.46,7.81-10.63,10.66-2.51,1.71-5.14,3.34-7.61,5.13-.08.13-.17.25-.24.37A2.21,2.21,0,0,0,235.83,90.4Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09,107.46a2.53,2.53,0,0,0,1.27,2,2,2,0,0,0,2.07-.43,3.87,3.87,0,0,0,.5-4.68,2.35,2.35,0,0,0-2.89-.6C233,104.49,232.92,106.37,233.09,107.46Z",
    style: {
      fill: "#53479D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.83,90.4c.53.5,1.34.61,1.85,1.12.79.8.48,2.17-.14,3.11a12.45,12.45,0,0,0-1.86,2.79,3.08,3.08,0,0,0,5,3.26,9.93,9.93,0,0,0,1.44-2A2.93,2.93,0,0,1,244,97.34a2.32,2.32,0,0,1,2.27,1.6,5.41,5.41,0,0,1,0,3,14.23,14.23,0,0,0-.45,3,3.06,3.06,0,0,0,1.26,2.58,2.74,2.74,0,0,0,3.36-.72,4.83,4.83,0,0,0,.95-3.51,23,23,0,0,0-.76-3.65,8,8,0,0,1-.16-3.7,2.48,2.48,0,0,1,.73-1.32,1.35,1.35,0,0,1,1.43-.27c.68.33.81,1.23.91,2s.43,1.66,1.19,1.74a1.26,1.26,0,0,0,1.08-.56,3.9,3.9,0,0,0,.5-1.17l.06-.23.09-.91c.71-7.79.1-15.43-.56-23.19a.94.94,0,0,0-1.75-.38c-2.34,4.38-6.46,7.81-10.63,10.66-2.51,1.71-5.14,3.34-7.61,5.13-.08.13-.17.25-.24.37A2.21,2.21,0,0,0,235.83,90.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09,107.46a2.53,2.53,0,0,0,1.27,2,2,2,0,0,0,2.07-.43,3.87,3.87,0,0,0,.5-4.68,2.35,2.35,0,0,0-2.89-.6C233,104.49,232.92,106.37,233.09,107.46Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.09,84.49a6.08,6.08,0,0,0-2.15,1.73,1.78,1.78,0,0,0,.37,2.46,1.7,1.7,0,0,0,1.66-.13,4.79,4.79,0,0,0,1.23-1.23c1.22-1.57,2.36-3.21,3.42-4.89.89-1.42,2.5-3.41,2.77-5.07A24.93,24.93,0,0,1,245.09,84.49Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,92.67a1,1,0,0,0,.77.81,1.41,1.41,0,0,0,1.33-.81c.41-.68.6-2.36-.65-2.31C240.55,90.39,239.82,91.94,240,92.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.57b3c8fd805f41e97a132d6286327c0c.svg";
export { ForwardRef as ReactComponent };